(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["VueBook"] = factory(require("vue"));
	else
		root["VueBook"] = factory(root["vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_vue__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/app.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/@fortawesome/fontawesome-svg-core/index.es.js":
/*!**************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/fontawesome-svg-core/index.es.js ***!
  \**************************************************************************************************/
/*! exports provided: icon, noAuto, config, toHtml, layer, text, counter, library, dom, parse, findIconDefinition */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "icon", function() { return icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noAuto", function() { return noAuto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toHtml", function() { return toHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "layer", function() { return layer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "counter", function() { return counter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "library", function() { return library; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dom", function() { return dom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findIconDefinition", function() { return findIconDefinition; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return "development" === 'production';
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  'fas': 'solid',
  'far': 'regular',
  'fal': 'light',
  'fab': 'brands',
  'fa': 'solid'
};
var STYLE_TO_PREFIX = {
  'solid': 'fas',
  'regular': 'far',
  'light': 'fal',
  'brands': 'fab'
};
var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Brands|Free|Pro)/;
var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  'normal': 'far',
  '300': 'fal'
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter'].concat(oneToTen.map(function (n) {
  return "".concat(n, "x");
})).concat(oneToTwenty.map(function (n) {
  return "w-".concat(n);
}));

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread({}, _default, initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;

var config = _objectSpread({}, _config);

WINDOW.FontAwesomeConfig = config;

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

var PENDING = 'pending';
var SETTLED = 'settled';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';

var NOOP = function NOOP() {};

var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var asyncQueue = [];
var asyncTimer;

function asyncFlush() {
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++) {
    asyncQueue[i][0](asyncQueue[i][1]);
  } // reset async asyncQueue


  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg) {
  asyncQueue.push([callback, arg]);

  if (!asyncTimer) {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}

function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch (e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber) {
  var owner = subscriber.owner;
  var settled = owner._state;
  var value = owner._data;
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function') {
    settled = FULFILLED;

    try {
      value = callback(value);
    } catch (e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value)) {
    if (settled === FULFILLED) {
      resolve(promise, value);
    }

    if (settled === REJECTED) {
      reject(promise, value);
    }
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value) {
      throw new TypeError('A promises callback cannot return that same promise.');
    }

    if (value && (typeof value === 'function' || _typeof(value) === 'object')) {
      // then should be retrieved only once
      var then = value.then;

      if (typeof then === 'function') {
        then.call(value, function (val) {
          if (!resolved) {
            resolved = true;

            if (value === val) {
              fulfill(promise, val);
            } else {
              resolve(promise, val);
            }
          }
        }, function (reason) {
          if (!resolved) {
            resolved = true;
            reject(promise, reason);
          }
        });
        return true;
      }
    }
  } catch (e) {
    if (!resolved) {
      reject(promise, e);
    }

    return true;
  }

  return false;
}

function resolve(promise, value) {
  if (promise === value || !handleThenable(promise, value)) {
    fulfill(promise, value);
  }
}

function fulfill(promise, value) {
  if (promise._state === PENDING) {
    promise._state = SETTLED;
    promise._data = value;
    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason) {
  if (promise._state === PENDING) {
    promise._state = SETTLED;
    promise._data = reason;
    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  promise._then = promise._then.forEach(invokeCallback);
}

function publishFulfillment(promise) {
  promise._state = FULFILLED;
  publish(promise);
}

function publishRejection(promise) {
  promise._state = REJECTED;
  publish(promise);

  if (!promise._handled && isNode) {
    global.process.emit('unhandledRejection', promise._data, promise);
  }
}

function notifyRejectionHandled(promise) {
  global.process.emit('rejectionHandled', promise);
}
/**
 * @class
 */


function P(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('Promise resolver ' + resolver + ' is not a function');
  }

  if (this instanceof P === false) {
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
  }

  this._then = [];
  invokeResolver(resolver, this);
}

P.prototype = {
  constructor: P,
  _state: PENDING,
  _then: null,
  _data: undefined,
  _handled: false,
  then: function then(onFulfillment, onRejection) {
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if ((onRejection || onFulfillment) && !this._handled) {
      this._handled = true;

      if (this._state === REJECTED && isNode) {
        asyncCall(notifyRejectionHandled, this);
      }
    }

    if (this._state === FULFILLED || this._state === REJECTED) {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    } else {
      // subscribe
      this._then.push(subscriber);
    }

    return subscriber.then;
  },
  catch: function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

P.all = function (promises) {
  if (!Array.isArray(promises)) {
    throw new TypeError('You must pass an array to Promise.all().');
  }

  return new P(function (resolve, reject) {
    var results = [];
    var remaining = 0;

    function resolver(index) {
      remaining++;
      return function (value) {
        results[index] = value;

        if (! --remaining) {
          resolve(results);
        }
      };
    }

    for (var i = 0, promise; i < promises.length; i++) {
      promise = promises[i];

      if (promise && typeof promise.then === 'function') {
        promise.then(resolver(i), reject);
      } else {
        results[i] = promise;
      }
    }

    if (!remaining) {
      resolve(results);
    }
  });
};

P.race = function (promises) {
  if (!Array.isArray(promises)) {
    throw new TypeError('You must pass an array to Promise.race().');
  }

  return new P(function (resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++) {
      promise = promises[i];

      if (promise && typeof promise.then === 'function') {
        promise.then(resolve, reject);
      } else {
        resolve(promise);
      }
    }
  });
};

P.resolve = function (value) {
  if (value && _typeof(value) === 'object' && value.constructor === P) {
    return value;
  }

  return new P(function (resolve) {
    resolve(value);
  });
};

P.reject = function (reason) {
  return new P(function (resolve, reject) {
    reject(reason);
  });
};

var picked = typeof Promise === 'function' ? Promise : P;

var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}
function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = '';

  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }

  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};
function makeIconMasking (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [{
      tag: 'path',
      attributes: _objectSpread({}, mainPath.attributes, trans.path, {
        fill: 'black'
      })
    }]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(nextUniqueId());
  var clipId = "clip-".concat(nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: [maskPath]
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var widthClass = "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    transform: transform,
    symbol: symbol,
    styles: extra.styles
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

  var attributes = _objectSpread({}, extra.attributes, title ? {
    'title': title
  } : {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _objectSpread({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform: transform,
      startCentered: true,
      width: width,
      height: height
    });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;

  var attributes = _objectSpread({}, extra.attributes, title ? {
    'title': title
  } : {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];
  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }

  return val;
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = "FA \"5.7.2\"";

var begin = function begin(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};

var perf = {
  begin: begin,
  end: end
};

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = 'far' in styles;
  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};
build();
function byUnicode(prefix, unicode) {
  return _byUnicode[prefix][unicode];
}
function byLigature(prefix, ligature) {
  return _byLigature[prefix][ligature];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}

var styles$1 = namespace.styles;
var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalIcon(values) {
  return values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles$1[cls]) {
      acc.prefix = cls;
    } else if (config.autoFetchSvg && ['fas', 'far', 'fal', 'fab', 'fa'].indexOf(cls) > -1) {
      acc.prefix = cls;
    } else if (iconName) {
      var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};
      acc.iconName = shim.iconName || iconName;
      acc.prefix = shim.prefix || acc.prefix;
    } else if (cls !== config.replacementClass && cls.indexOf('fa-w-') !== 0) {
      acc.rest.push(cls);
    }

    return acc;
  }, emptyCanonicalIcon());
}
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var noop$2 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];
    var newOuterHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');

    if (node.parentNode && node.outerHTML) {
      node.outerHTML = newOuterHTML + (config.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? "<!-- ".concat(node.outerHTML, " -->") : '');
    } else if (node.parentNode) {
      var newNode = document.createElement('span');
      node.parentNode.replaceChild(newNode, node);
      newNode.outerHTML = newOuterHTML;
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement

    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.style;
    var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
      if (cls === config.replacementClass || cls.match(forSvg)) {
        acc.toSvg.push(cls);
      } else {
        acc.toNode.push(cls);
      }

      return acc;
    }, {
      toNode: [],
      toSvg: []
    });
    abstract[0].attributes.class = splitClasses.toSvg.join(' ');
    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute('class', splitClasses.toNode.join(' '));
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};
function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$2;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = WINDOW.requestAnimationFrame || function (op) {
      return op();
    };

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var treeCallback = options.treeCallback,
      nodeCallback = options.nodeCallback,
      pseudoElementsCallback = options.pseudoElementsCallback,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class') {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
          if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
        } else {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  var style = node.getAttribute('style');
  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
}

function toHex(unicode) {
  var result = '';

  for (var i = 0; i < unicode.length; i++) {
    var hex = unicode.charCodeAt(i).toString(16);
    result += ('000' + hex).slice(-4);
  }

  return result;
}

function classParser (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  var val = getCanonicalIcon(classArray(node));

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.prefix && innerText.length > 1) {
    val.iconName = byLigature(val.prefix, node.innerText);
  } else if (val.prefix && innerText.length === 1) {
    val.iconName = byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};
function transformParser (node) {
  return parseTransformString(node.getAttribute('data-fa-transform'));
}

function symbolParser (node) {
  var symbol = node.getAttribute('data-fa-symbol');
  return symbol === null ? false : symbol === '' ? true : symbol;
}

function attributesParser (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }

    return acc;
  }, {});
  var title = node.getAttribute('title');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }

  return extraAttributes;
}

function maskParser (node) {
  var mask = node.getAttribute('data-fa-mask');

  if (!mask) {
    return emptyCanonicalIcon();
  } else {
    return getCanonicalIcon(mask.split(' ').map(function (i) {
      return i.trim();
    }));
  }
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraStyles = styleParser(node);
  var transform = transformParser(node);
  var symbol = symbolParser(node);
  var extraAttributes = attributesParser(node);
  var mask = maskParser(node);
  return {
    iconName: iconName,
    title: node.getAttribute('title'),
    prefix: prefix,
    transform: transform,
    symbol: symbol,
    mask: mask,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  };
}

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}
MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

var DOT = {
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
};
var QUESTION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
};
var missing = {
  tag: 'g',
  children: [RING, DOT, QUESTION, EXCLAMATION]
};

var styles$2 = namespace.styles;
function findIcon(iconName, prefix) {
  return new picked(function (resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: missing
    };

    if (iconName && prefix && styles$2[prefix] && styles$2[prefix][iconName]) {
      var icon = styles$2[prefix][iconName];
      var width = icon[0];
      var height = icon[1];
      var vectorData = icon.slice(4);
      val = {
        found: true,
        width: width,
        height: height,
        icon: {
          tag: 'path',
          attributes: {
            fill: 'currentColor',
            d: vectorData[0]
          }
        }
      };
      return resolve(val);
    }

    if (iconName && prefix && !config.showMissingIcons) {
      reject(new MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
    } else {
      resolve(val);
    }
  });
}

var styles$3 = namespace.styles;

function generateSvgReplacementMutation(node, nodeMeta) {
  var iconName = nodeMeta.iconName,
      title = nodeMeta.title,
      prefix = nodeMeta.prefix,
      transform = nodeMeta.transform,
      symbol = nodeMeta.symbol,
      mask = nodeMeta.mask,
      extra = nodeMeta.extra;
  return new picked(function (resolve, reject) {
    picked.all([findIcon(iconName, prefix), findIcon(mask.iconName, mask.prefix)]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          main = _ref2[0],
          mask = _ref2[1];

      resolve([node, makeInlineSvgAbstract({
        icons: {
          main: main,
          mask: mask
        },
        prefix: prefix,
        iconName: iconName,
        transform: transform,
        symbol: symbol,
        mask: mask,
        title: title,
        extra: extra,
        watchable: true
      })]);
    });
  });
}

function generateLayersText(node, nodeMeta) {
  var title = nodeMeta.title,
      transform = nodeMeta.transform,
      extra = nodeMeta.extra;
  var width = null;
  var height = null;

  if (IS_IE) {
    var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
    var boundingClientRect = node.getBoundingClientRect();
    width = boundingClientRect.width / computedFontSize;
    height = boundingClientRect.height / computedFontSize;
  }

  if (config.autoA11y && !title) {
    extra.attributes['aria-hidden'] = 'true';
  }

  return picked.resolve([node, makeLayersTextAbstract({
    content: node.innerHTML,
    width: width,
    height: height,
    transform: transform,
    title: title,
    extra: extra,
    watchable: true
  })]);
}

function generateMutation(node) {
  var nodeMeta = parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return generateLayersText(node, nodeMeta);
  } else {
    return generateSvgReplacementMutation(node, nodeMeta);
  }
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return;
  var htmlClassList = DOCUMENT.documentElement.classList;

  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };

  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$3);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
    return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return;
  }

  var candidates = toArray(root.querySelectorAll(prefixesDomQuery));

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return;
  }

  var mark = perf.begin('onTree');
  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e instanceof MissingIcon) {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);
  return new picked(function (resolve, reject) {
    picked.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(function () {
      mark();
      reject();
    });
  });
}
function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}

function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new picked(function (resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }

    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function (c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
    var fontWeight = styles.getPropertyValue('font-weight');

    if (alreadyProcessedPseudoElement && !fontFamily) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily) {
      var content = styles.getPropertyValue('content');
      var prefix = ~['Light', 'Regular', 'Solid', 'Brands'].indexOf(fontFamily[1]) ? STYLE_TO_PREFIX[fontFamily[1].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
      var iconName = byUnicode(prefix, toHex(content.length === 3 ? content.substr(1, 1) : content)); // Only convert the pseudo element in this :before/:after position into an icon if we haven't
      // already done so with the same prefix and iconName

      if (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconName) {
        node.setAttribute(pendingAttribute, iconName);

        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }

        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread({}, meta, {
            icons: {
              main: main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix,
            iconName: iconName,
            extra: extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement('svg');

          if (position === ':before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }

          element.outerHTML = abstract.map(function (a) {
            return toHtml(a);
          }).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}

function replace(node) {
  return picked.all([replaceForPosition(node, ':before'), replaceForPosition(node, ':after')]);
}

function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}

function searchPseudoElements (root) {
  if (!IS_DOM) return;
  return new picked(function (resolve, reject) {
    var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    var end = perf.begin('searchPseudoElements');
    disableObservation();
    picked.all(operations).then(function () {
      end();
      enableObservation();
      resolve();
    }).catch(function () {
      end();
      enableObservation();
      reject();
    });
  });
}

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}";

function css () {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var Library =
/*#__PURE__*/
function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function prepIcon(icon) {
  var width = icon[0];
  var height = icon[1];
  var vectorData = icon.slice(4);
  return {
    found: true,
    width: width,
    height: height,
    icon: {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData[0]
      }
    }
  };
}

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());

    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
      iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  disconnect();
};
var _cssInserted = false;
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      ensureCss();
      var _params$node = params.node,
          node = _params$node === void 0 ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === void 0 ? function () {} : _params$callback;

      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }

      return onTree(node, callback);
    } else {
      return picked.reject('Operation requires a DOM of some kind.');
    }
  },
  css: css,
  insertCss: function insertCss$$1() {
    if (!_cssInserted) {
      insertCss(css());

      _cssInserted = true;
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot,
        observeMutationsRoot = params.observeMutationsRoot;

    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });
      observe({
        treeCallback: onTree,
        nodeCallback: onNode,
        pseudoElementsCallback: searchPseudoElements,
        observeMutationsRoot: observeMutationsRoot
      });
    });
  }
};
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: prepIcon(icon),
        mask: mask ? prepIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});
var text = function text(content) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform2 = params.transform,
      transform = _params$transform2 === void 0 ? meaninglessTransform : _params$transform2,
      _params$title2 = params.title,
      title = _params$title2 === void 0 ? null : _params$title2,
      _params$classes2 = params.classes,
      classes = _params$classes2 === void 0 ? [] : _params$classes2,
      _params$attributes2 = params.attributes,
      attributes = _params$attributes2 === void 0 ? {} : _params$attributes2,
      _params$styles2 = params.styles,
      styles = _params$styles2 === void 0 ? {} : _params$styles2;
  return apiObject({
    type: 'text',
    content: content
  }, function () {
    ensureCss();
    return makeLayersTextAbstract({
      content: content,
      transform: _objectSpread({}, meaninglessTransform, transform),
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray(classes))
      }
    });
  });
};
var counter = function counter(content) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$title3 = params.title,
      title = _params$title3 === void 0 ? null : _params$title3,
      _params$classes3 = params.classes,
      classes = _params$classes3 === void 0 ? [] : _params$classes3,
      _params$attributes3 = params.attributes,
      attributes = _params$attributes3 === void 0 ? {} : _params$attributes3,
      _params$styles3 = params.styles,
      styles = _params$styles3 === void 0 ? {} : _params$styles3;
  return apiObject({
    type: 'counter',
    content: content
  }, function () {
    ensureCss();
    return makeLayersCounterAbstract({
      content: content.toString(),
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
      }
    });
  });
};
var layer = function layer(assembler) {
  return apiObject({
    type: 'layer'
  }, function () {
    ensureCss();
    var children = [];
    assembler(function (args) {
      Array.isArray(args) ? args.map(function (a) {
        children = children.concat(a.abstract);
      }) : children = children.concat(args.abstract);
    });
    return [{
      tag: 'span',
      attributes: {
        class: "".concat(config.familyPrefix, "-layers")
      },
      children: children
    }];
  });
};
var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  library: library,
  parse: parse,
  findIconDefinition: findIconDefinition,
  icon: icon,
  text: text,
  counter: counter,
  layer: layer,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "../../node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../timers-browserify/main.js */ "../../node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faArrowsAltV.js":
/*!******************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faArrowsAltV.js ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'arrows-alt-v';
var width = 256;
var height = 512;
var ligatures = [];
var unicode = 'f338';
var svgPathData = 'M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faArrowsAltV = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faBars.js":
/*!************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faBars.js ***!
  \************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'bars';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f0c9';
var svgPathData = 'M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faBars = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faCaretDown.js":
/*!*****************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faCaretDown.js ***!
  \*****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'caret-down';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f0d7';
var svgPathData = 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faCaretDown = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faCaretRight.js":
/*!******************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faCaretRight.js ***!
  \******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'caret-right';
var width = 192;
var height = 512;
var ligatures = [];
var unicode = 'f0da';
var svgPathData = 'M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faCaretRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faDotCircle.js":
/*!*****************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faDotCircle.js ***!
  \*****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'dot-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f192';
var svgPathData = 'M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faDotCircle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faExchangeAlt.js":
/*!*******************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faExchangeAlt.js ***!
  \*******************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'exchange-alt';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f362';
var svgPathData = 'M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faExchangeAlt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faFile.js":
/*!************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faFile.js ***!
  \************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'file';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f15b';
var svgPathData = 'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faFile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faFolder.js":
/*!**************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faFolder.js ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'folder';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f07b';
var svgPathData = 'M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faFolder = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faSearch.js":
/*!**************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faSearch.js ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'search';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f002';
var svgPathData = 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSearch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faServer.js":
/*!**************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faServer.js ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'server';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f233';
var svgPathData = 'M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faServer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faSync.js":
/*!************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faSync.js ***!
  \************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'sync';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f021';
var svgPathData = 'M440.935 12.574l3.966 82.766C399.416 41.904 331.674 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h49.084c5.57 0 10.377-3.842 11.676-9.259C103.407 137.408 172.931 80 256 80c60.893 0 114.512 30.856 146.104 77.801l-101.53-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12h-47.411c-6.853 0-12.315 5.729-11.987 12.574zM256 432c-60.895 0-114.517-30.858-146.109-77.805l101.868 4.871c6.845.327 12.573-5.134 12.573-11.986v-47.412c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12V500c0 6.627 5.373 12 12 12h47.385c6.863 0 12.328-5.745 11.985-12.599l-4.129-82.575C112.725 470.166 180.405 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176h-49.084c-5.57 0-10.377 3.842-11.676 9.259C408.593 374.592 339.069 432 256 432z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSync = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/free-solid-svg-icons/faTimes.js":
/*!*************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/free-solid-svg-icons/faTimes.js ***!
  \*************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'times';
var width = 352;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faTimes = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;

/***/ }),

/***/ "../../node_modules/@fortawesome/vue-fontawesome/index.es.js":
/*!*********************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/@fortawesome/vue-fontawesome/index.es.js ***!
  \*********************************************************************************************/
/*! exports provided: FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FontAwesomeIcon", function() { return FontAwesomeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FontAwesomeLayers", function() { return FontAwesomeLayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FontAwesomeLayersText", function() { return FontAwesomeLayersText; });
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ "../../node_modules/@fortawesome/fontawesome-svg-core/index.es.js");


var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var humps = createCommonjsModule(function (module) {
(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (false) {} else if ( true && module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }

})(commonjsGlobal);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();

    acc[prop] = value;

    return acc;
  }, {});
}

function classToObject(cls) {
  return cls.split(/\s+/).reduce(function (acc, c) {
    acc[c] = true;

    return acc;
  }, {});
}

function combineClassObjects() {
  for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }

  return objs.reduce(function (acc, obj) {
    if (Array.isArray(obj)) {
      acc = acc.concat(obj);
    } else {
      acc.push(obj);
    }

    return acc;
  }, []);
}

function convert(h, element) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var children = (element.children || []).map(convert.bind(null, h));

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc['class'] = classToObject(val);
        break;
      case 'style':
        acc['style'] = styleToObject(val);
        break;
      default:
        acc.attrs[key] = val;
    }

    return acc;
  }, { 'class': {}, style: {}, attrs: {} });

  var _data$class = data.class,
      dClass = _data$class === undefined ? {} : _data$class,
      _data$style = data.style,
      dStyle = _data$style === undefined ? {} : _data$style,
      _data$attrs = data.attrs,
      dAttrs = _data$attrs === undefined ? {} : _data$attrs,
      remainingData = objectWithoutProperties(data, ['class', 'style', 'attrs']);


  if (typeof element === 'string') {
    return element;
  } else {
    return h(element.tag, _extends({
      class: combineClassObjects(mixins.class, dClass),
      style: _extends({}, mixins.style, dStyle),
      attrs: _extends({}, mixins.attrs, dAttrs)
    }, remainingData, {
      props: props
    }), children);
  }
}

var PRODUCTION = false;

try {
  PRODUCTION = "development" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty({}, key, value) : {};
}

function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-pulse': props.pulse,
    'fa-fw': props.fixedWidth,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, defineProperty(_classes, 'fa-' + props.size, props.size !== null), defineProperty(_classes, 'fa-rotate-' + props.rotation, props.rotation !== null), defineProperty(_classes, 'fa-pull-' + props.pull, props.pull !== null), _classes);

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

function addStaticClass(to, what) {
  var val = (to || '').length === 0 ? [] : [to];

  return val.concat(what).join(' ');
}

function normalizeIconArgs(icon$$1) {
  if (icon$$1 === null) {
    return null;
  }

  if ((typeof icon$$1 === 'undefined' ? 'undefined' : _typeof(icon$$1)) === 'object' && icon$$1.prefix && icon$$1.iconName) {
    return icon$$1;
  }

  if (Array.isArray(icon$$1) && icon$$1.length === 2) {
    return { prefix: icon$$1[0], iconName: icon$$1[1] };
  }

  if (typeof icon$$1 === 'string') {
    return { prefix: 'fas', iconName: icon$$1 };
  }
}

var FontAwesomeIcon = {
  name: 'FontAwesomeIcon',

  functional: true,

  props: {
    border: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    },
    flip: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['horizontal', 'vertical', 'both'].indexOf(value) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: true
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    listItem: {
      type: Boolean,
      default: false
    },
    pull: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['right', 'left'].indexOf(value) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: false
    },
    rotation: {
      type: Number,
      default: null,
      validator: function validator(value) {
        return [90, 180, 270].indexOf(value) > -1;
      }
    },
    size: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].indexOf(value) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: false
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: null
    }
  },

  render: function render(createElement, context) {
    var props = context.props;
    var iconArgs = props.icon,
        maskArgs = props.mask,
        symbol = props.symbol,
        title = props.title;

    var icon$$1 = normalizeIconArgs(iconArgs);
    var classes = objectWithKey('classes', classList(props));
    var transform = objectWithKey('transform', typeof props.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__["parse"].transform(props.transform) : props.transform);
    var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));

    var renderedIcon = Object(_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__["icon"])(icon$$1, _extends({}, classes, transform, mask, { symbol: symbol, title: title }));

    if (!renderedIcon) {
      return log('Could not find one or more icon(s)', icon$$1, mask);
    }

    var abstract = renderedIcon.abstract;

    var convertCurry = convert.bind(null, createElement);

    return convertCurry(abstract[0], {}, context.data);
  }
};

var FontAwesomeLayers = {
  name: 'FontAwesomeLayers',

  functional: true,

  props: {
    fixedWidth: {
      type: Boolean,
      default: false
    }
  },

  render: function render(createElement, context) {
    var familyPrefix = _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__["config"].familyPrefix;
    var staticClass = context.data.staticClass;


    var classes = [familyPrefix + '-layers'].concat(toConsumableArray(context.props.fixedWidth ? [familyPrefix + '-fw'] : []));

    return createElement('div', _extends({}, context.data, {
      staticClass: addStaticClass(staticClass, classes)
    }), context.children);
  }
};

var FontAwesomeLayersText = {
  name: 'FontAwesomeLayersText',

  functional: true,

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    transform: {
      type: [String, Object],
      default: null
    }
  },

  render: function render(createElement, context) {
    var props = context.props;

    var transform = objectWithKey('transform', typeof props.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__["parse"].transform(props.transform) : props.transform);

    var renderedText = Object(_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__["text"])(props.value.toString(), _extends({}, transform));

    var abstract = renderedText.abstract;


    var convertCurry = convert.bind(null, createElement);

    return convertCurry(abstract[0], {}, context.data);
  }
};



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/asva-helpers/dist/src/index.esm.js":
/*!***************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/asva-helpers/dist/src/index.esm.js ***!
  \***************************************************************************************/
/*! exports provided: ArrayHelpers, AsyncHelpers, DecimalHelpers, DomHelpers, MappingHelpers, MathHelpers, ObjectHelpers, RandomValueGenerator, StringHelpers, ValueHelpers */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayHelpers", function() { return ArrayHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncHelpers", function() { return AsyncHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DecimalHelpers", function() { return DecimalHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomHelpers", function() { return DomHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MappingHelpers", function() { return MappingHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MathHelpers", function() { return MathHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectHelpers", function() { return ObjectHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RandomValueGenerator", function() { return RandomValueGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StringHelpers", function() { return StringHelpers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValueHelpers", function() { return ValueHelpers; });
// TODO: test
var ValueHelpers = /** @class */ (function () {
    function ValueHelpers() {
    }
    ValueHelpers.isEmpty = function (value) {
        if (Array.isArray(value))
            return ValueHelpers.isEmptyArray(value);
        if (value instanceof Object)
            return ValueHelpers.isEmptyObject(value);
        return !value;
    };
    ValueHelpers.isEmptyArray = function (value) {
        return !(Array.isArray(value) && value.length);
    };
    ValueHelpers.isEmptyObject = function (value) {
        return !(value instanceof Object && Object.keys(value).length);
    };
    return ValueHelpers;
}());

var ObjectHelpers = /** @class */ (function () {
    function ObjectHelpers() {
    }
    /**
     * Find nested branch with object that meets criteria.
     * Branch is returned in form of array, where index means depth.
     *
     * Example:
     *
     * const parent =
     * [
     *   {
     *     one: {name: 1},
     *     two: {name: 2},
     *   },
     *   {
     *     one: {name: 3},
     *     two: {name: 4},
     *   },
     * ]
     *
     * ObjectHelpers.traverseBranch(parent, {name: 4})
     * [
     *   parent,
     *   {one: {name: 3}, two: {name: 4}},
     *   {name: 4},
     * ]
     *
     * @param parent object|array
     * @param criteria object
     * @returns {*}
     */
    ObjectHelpers.traverseBranch = function (parent, criteria) {
        var result = ObjectHelpers.findNestedRecursive(parent, criteria);
        return result ? [parent].concat(result) : [];
    };
    /**
     * @protected
     * @param parent
     * @param criteria
     * @returns {*}
     */
    ObjectHelpers.findNestedRecursive = function (parent, criteria) {
        if (!(Array.isArray(parent) || typeof parent === 'object')) {
            return null;
        }
        for (var index in parent) {
            var item = parent[index];
            if (item && typeof item === 'object' && ObjectHelpers.meetsCriteria(item, criteria)) {
                return [item];
            }
            var result = ObjectHelpers.findNestedRecursive(item, criteria);
            if (result) {
                return [item].concat(result);
            }
        }
        return null;
    };
    /**
     * Traverse branches of object|array tree (and not trunk itself)
     * Truthy value from closure stops traversing.
     * Won't traverse recursive nodes.
     */
    ObjectHelpers.traverseBranches = function (parent, closure, pool) {
        if (pool === void 0) { pool = []; }
        if (pool.includes(parent)) {
            return;
        }
        pool.push(parent);
        for (var index in parent) {
            var child = parent[index];
            if (typeof child === 'object') {
                if (closure(child, parent, index)) {
                    return;
                }
                ObjectHelpers.traverseBranches(child, closure, pool);
            }
        }
    };
    /**
     * Traverse tree of object|array.
     */
    ObjectHelpers.traverse = function (node, closure) {
        closure(node);
        ObjectHelpers.traverseBranches(node, closure);
    };
    /**
     * Object meets criteria.
     *
     * @protected
     * @param object
     * @param criteria
     * @returns {boolean}
     */
    ObjectHelpers.meetsCriteria = function (object, criteria) {
        for (var index in criteria) {
            if (criteria[index] !== object[index]) {
                return false;
            }
        }
        return true;
    };
    /**
     * Check if object has array|object descendants.
     */
    ObjectHelpers.hasDescendants = function (object) {
        for (var index in object) {
            var item = object[index];
            if (item && typeof item === 'object') {
                return true;
            }
        }
        return false;
    };
    /**
     * Flatten array|object tree.
     */
    ObjectHelpers.flattenTree = function (object) {
        var result = [object];
        for (var index in object) {
            var property = object[index];
            if (property && typeof property === 'object') {
                result = result.concat(ObjectHelpers.flattenTree(property));
            }
        }
        return result;
    };
    /**
     * Invert object key to avlues.
     */
    ObjectHelpers.invert = function (object) {
        var invertedObject = {};
        Object.keys(object).map(function (key) {
            invertedObject[object[key]] = key;
        });
        return invertedObject;
    };
    /**
     * refresh current instance via merge with given delegate.
     * if new instance have options === undefined || null, they will be ignored
     *
     * NOTE: fast hack @d3
     */
    ObjectHelpers.fresh = function (source, data) {
        var newObject = {};
        Object.keys(data).forEach(function (key) {
            if (!ValueHelpers.isEmpty(data[key])) {
                newObject[key] = data[key];
            }
        });
        Object.assign(source, newObject);
    };
    return ObjectHelpers;
}());

var count = 1;
var RandomValueGenerator = /** @class */ (function () {
    function RandomValueGenerator() {
    }
    /**
     * Get random id
     */
    RandomValueGenerator.getUniqueId = function () {
        return ++count;
    };
    /**
     * Get random number in specified range.
     */
    RandomValueGenerator.getNumber = function (min, max) {
        if (min === void 0) { min = 5; }
        if (max === void 0) { max = 50; }
        max = max + 1;
        return Math.floor(Math.random() * (max - min)) + min;
    };
    /**
     * Get random string in specified range.
     */
    RandomValueGenerator.getString = function (size, possible) {
        if (size === void 0) { size = 5; }
        if (possible === void 0) { possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; }
        var text = '';
        RandomValueGenerator.getArrayByClosure(function () {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }, size);
        return text;
    };
    /**
     * Get random date in past.
     */
    RandomValueGenerator.takeFromArray = function (array) {
        return array[Math.floor(Math.random() * array.length)];
    };
    /**
     * Get unique id. @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
     */
    RandomValueGenerator.getUIID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    /**
     * Get random date in past.
     */
    // static getDateFromPast (): Day {
    //   return new Day(RandomValueGenerator.getNumber(0, +new Date()))
    // }
    /**
     * Get random date in future.
     */
    // static getDateFromFuture (): Day {
    //   return new Day(RandomValueGenerator.getNumber(+new Date(), (+new Date()) * 2))
    // }
    /**
     * Get random time.
     */
    // static getRandomTime (): Time {
    //   return new Time(new Date(RandomValueGenerator.getNumber(0, +new Date() * 1000)))
    // }
    /**
     * Get random date and time in past.
     */
    // static getDateTimeFromPast (): DayTime {
    //   return new DayTime({
    //     day: RandomValueGenerator.getDateFromPast(),
    //     time: RandomValueGenerator.getRandomTime(),
    //   })
    // }
    /**
     * Get random date and time in future.
     */
    // static getDateTimeFromFuture (): DayTime {
    //   return new DayTime({
    //     day: RandomValueGenerator.getDateFromFuture(),
    //     time: RandomValueGenerator.getRandomTime(),
    //   })
    // }
    /**
     * Get random boolean.
     */
    RandomValueGenerator.getBoolean = function () {
        return Math.random() >= 0.5;
    };
    /**
     * Get array of undefined of length specified.
     */
    RandomValueGenerator.getCleanArray = function (length) {
        if (length === void 0) { length = 0; }
        return Array.apply(null, Array(length));
    };
    /**
     * Get array of random size in range.
     */
    RandomValueGenerator.getArray = function (min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 3; }
        var length = RandomValueGenerator.getNumber(min, max);
        return RandomValueGenerator.getCleanArray(length);
    };
    RandomValueGenerator.getArrayByClosure = function (closure, size) {
        if (size === void 0) { size = 3; }
        return RandomValueGenerator.getCleanArray(size).map(closure);
    };
    return RandomValueGenerator;
}());

var ArrayHelpers = /** @class */ (function () {
    function ArrayHelpers() {
    }
    /**
     * Toggle item in array. Check by identity.
     */
    ArrayHelpers.toggle = function (array, item) {
        var itemIndex = array.indexOf(item);
        if (itemIndex === -1) {
            array.push(item);
            return array;
        }
        array.splice(itemIndex, 1);
        return array;
    };
    /**
     * Remove item from array via identity check.
     */
    ArrayHelpers.remove = function (array, item) {
        var result = array.slice();
        var foundItemIndex = array.indexOf(item);
        if (foundItemIndex !== -1) {
            result.splice(foundItemIndex, 1);
        }
        return result;
    };
    /**
     * Remove item from array via identity check.
     */
    ArrayHelpers.removeByIndex = function (array, index) {
        var result = array.slice();
        result.splice(index, 1);
        return result;
    };
    /**
     * Remove item from array via identity check.
     */
    ArrayHelpers.removeMany = function (array, arrayToRemove) {
        return arrayToRemove.reduce(function (accumulator, item) {
            return ArrayHelpers.remove(accumulator, item);
        }, array);
    };
    ArrayHelpers.fillToLength = function (array, length, fillWith) {
        var difference = length - array.length;
        if (difference > 0) {
            return array.concat(RandomValueGenerator.getArrayByClosure(fillWith, difference));
        }
        if (difference < 0) {
            var result = array.slice();
            result.length = length;
            return result;
        }
        // Difference === 0
        return array.slice();
    };
    /**
     * Find item by criteria.
     * Remove item if criteria was met for any.
     * Push provided item if criteria wasn't met.
     */
    ArrayHelpers.toggleByCriteria = function (array, criteria, item) {
        var existingItem = array.find(function (item) {
            return typeof criteria === 'function'
                ? criteria(item)
                : ObjectHelpers.meetsCriteria(item, criteria);
        });
        return existingItem ? ArrayHelpers.remove(array, existingItem)
            : array.concat([item]);
    };
    /**
     * Remove existing item by criteria and add new one.
     */
    ArrayHelpers.overrideByCriteria = function (array, criteria, item) {
        var existingItem = array.find(function (item) {
            return typeof criteria === 'function'
                ? criteria(item)
                : ObjectHelpers.meetsCriteria(item, criteria);
        });
        if (existingItem) {
            array = ArrayHelpers.remove(array, existingItem);
        }
        array.push(item);
        return array;
    };
    ArrayHelpers.removeByCondition = function (array, condition) {
        var existingItem = array.find(function (item) {
            return typeof condition === 'function'
                ? condition(item)
                : ObjectHelpers.meetsCriteria(item, condition);
        });
        if (!existingItem) {
            return array;
        }
        return ArrayHelpers.remove(array, existingItem);
    };
    ArrayHelpers.removeAllByCondition = function (array, condition) {
        var arrayLengthPrevious = array.length;
        while (true) {
            array = ArrayHelpers.removeByCondition(array, condition);
            if (array.length === arrayLengthPrevious) {
                return array;
            }
            arrayLengthPrevious = array.length;
        }
    };
    /**
     * Find index by criteria.
     */
    ArrayHelpers.findIndexByCriteria = function (array, criteria) {
        var foundItem = array.find(function (item) {
            return typeof criteria === 'function'
                ? criteria(item)
                : ObjectHelpers.meetsCriteria(item, criteria);
        });
        if (!foundItem) {
            return undefined;
        }
        return array.indexOf(foundItem);
    };
    ArrayHelpers.replaceOnceByCondition = function (array, condition, replacement) {
        var result = array.slice();
        var index = ArrayHelpers.findIndexByCriteria(array, condition);
        if (index) {
            result[index] = replacement;
        }
        return result;
    };
    /**
     * Sort array by object property.
     */
    ArrayHelpers.sortByProperty = function (array, parameter) {
        var result = array.slice();
        result.sort(function (a, b) {
            return a[parameter] > b[parameter] ? 1 : -1;
        });
        return result;
    };
    /**
     * Check if array elements are equal.
     * Method ignores ordering.
     * Works only on strings and numbers. Not objects.
     */
    ArrayHelpers.equals = function (one, two) {
        if (one === two) {
            return true;
        }
        if (one.length !== two.length) {
            return false;
        }
        one = one.slice().sort();
        two = two.slice().sort();
        return !one.some(function (item, index) {
            return item !== two[index];
        });
    };
    ArrayHelpers.getUnique = function (array) {
        return array.filter(function (value, index, self) { return array.indexOf(value) === index; });
    };
    /**
     * Group array into a set of arrays based on condition.
     * Condition should return a string.
     */
    ArrayHelpers.groupByCondition = function (array, condition) {
        var groups = {};
        array.forEach(function (item) {
            var result = condition(item);
            if (!groups[result]) {
                groups[result] = [];
            }
            groups[result].push(item);
        });
        return groups;
    };
    /**
     * Move array element from position to position
     */
    ArrayHelpers.sortMove = function (array, from, to) {
        var el = array[from];
        array.splice(from, 1);
        array.splice(to, 0, el);
        return array;
    };
    /**
     * Check if array objects are equals by id
     * TODO: test
     * TODO: thing about naming
     */
    ArrayHelpers.arraysEqualById = function (one, two) {
        if (one === two) {
            return true;
        }
        if (one.length !== two.length) {
            return false;
        }
        return !one.some(function (item, index) {
            return !(two[index] && two[index].id === item.id);
        });
    };
    ArrayHelpers.pushToPosition = function (array, position, item) {
        var clone = array.slice();
        clone.splice(position, 0, item);
        return clone;
    };
    return ArrayHelpers;
}());

var AsyncHelpers = /** @class */ (function () {
    function AsyncHelpers() {
    }
    /**
     * Basically setTimeout that returns promise.
     *
     * @param {Number | undefined} time
     * @returns {Promise}
     */
    AsyncHelpers.sleep = function (time) {
        if (time === void 0) { time = 0; }
        return new Promise(function (resolve) {
            setTimeout(resolve, time);
        });
    };
    AsyncHelpers.waitConditional = function (condition, iterationTimeout, maxTimeout, timeout) {
        if (iterationTimeout === void 0) { iterationTimeout = 20; }
        if (maxTimeout === void 0) { maxTimeout = 2000; }
        if (timeout === void 0) { timeout = 2000; }
        if (!timeout) {
            throw new Error('Time expired but condition is not met');
        }
        return new Promise(function (resolve) {
            setTimeout(function () {
                condition()
                    ? resolve()
                    : AsyncHelpers.waitConditional(condition, iterationTimeout, maxTimeout, timeout - iterationTimeout)
                        .then(resolve);
            }, iterationTimeout);
        });
    };
    return AsyncHelpers;
}());

var DecimalHelpers = /** @class */ (function () {
    function DecimalHelpers() {
    }
    /**
     * Round decimal with set amount of symbols after comma.
     */
    DecimalHelpers.setZeros = function (decimal, zeros) {
        if (zeros === void 0) { zeros = 2; }
        decimal = '' + decimal;
        var _a = (decimal + '').split('.'), _b = _a[0], beforeComma = _b === void 0 ? 0 : _b, _c = _a[1], afterComma = _c === void 0 ? 0 : _c;
        if (!afterComma) {
            afterComma = Array(zeros + 1).join('0');
        }
        return beforeComma + '.' + afterComma.slice(0, zeros);
    };
    /**
     * Add zeros to front of number.
     * @param item
     * @param zeros Max quantity of zeros
     */
    DecimalHelpers.addZerosToFront = function (number, zeros) {
        if (zeros === void 0) { zeros = 2; }
        var stringifiedNumber = number + '';
        if (stringifiedNumber.length >= zeros) {
            return stringifiedNumber;
        }
        return Array(zeros - stringifiedNumber.length + 1).join('0') + stringifiedNumber;
    };
    /**
     * Returns number of digits after comma
     * @param num
     * @return {number}
     */
    DecimalHelpers.decimalPlaces = function (number) {
        var match = ('' + number).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) {
            return 0;
        }
        return Math.max(0, 
        // Number of digits right of decimal point.
        (match[1] ? match[1].length : 0)
            // Adjust for scientific notation.
            - (match[2] ? +match[2] : 0));
    };
    return DecimalHelpers;
}());

var DomHelpers = /** @class */ (function () {
    function DomHelpers() {
    }
    /**
     * Check if parent element nests child element.
     *
     * @param parent possible parent
     * @param child possible child
     * @returns {boolean}
     */
    DomHelpers.isChild = function (parent, child) {
        var node = child.parentNode;
        while (node) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };
    /**
     * Check if current element is detached from document dom tree.
     *
     * @param element
     * @returns {boolean}
     */
    DomHelpers.isDetached = function (element) {
        var tempElement = element;
        while (tempElement) {
            if (tempElement === document) {
                return false;
            }
            tempElement = element.parentNode;
        }
        return true;
    };
    /**
     * Detach node from current position and attach to new container
     */
    DomHelpers.reattach = function (node, container) {
        var parent = node.parentNode;
        // No parent node? Abort!
        if (!parent || parent === container) {
            return;
        }
        // Detach node from DOM.
        container.appendChild(node);
    };
    //TODO: make tests
    DomHelpers.computedStyle = function (el, prop, getComputedStyle, style) {
        getComputedStyle = window.getComputedStyle;
        style =
            // If we have getComputedStyle
            getComputedStyle ?
                // Query it
                // TODO: From CSS-Query notes, we might need (node, null) for FF
                getComputedStyle(el) :
                // Otherwise, we are in IE and use currentStyle
                el.currentStyle;
        if (style) {
            return style[
            // Switch to camelCase for CSSOM
            // DEV: Grabbed from jQuery
            // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
            // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
            prop.replace(/-(\w)/gi, function (word, letter) {
                return letter.toUpperCase();
            })];
        }
    };
    //TODO: make tests
    DomHelpers.getLineHeight = function (element) {
        var lineHeight = DomHelpers.computedStyle(element, 'line-height');
        if (lineHeight == 'normal') {
            // Normal line heights vary from browser to browser. The spec recommends
            // a value between 1.0 and 1.2 of the font size. Using 1.2 to be safe.
            lineHeight = parseInt(DomHelpers.computedStyle(element, 'font-size')) * 1.2;
        }
        return parseInt(lineHeight);
    };
    //TODO: make tests
    DomHelpers.getParentsForElement = function (element) {
        var parents = [];
        var parent = this.getParentForElement(element);
        while (parent) {
            parents.push(parent);
            parent = this.getParentForElement(element);
        }
        return parents;
    };
    /**
     * Find parent element. Return null when parent is window or there is no parent.
     */
    DomHelpers.getParentForElement = function (element) {
        var parent = element.parentElement;
        if (parent instanceof Window) {
            return null;
        }
        if (!parent) {
            return null;
        }
        return parent;
    };
    DomHelpers.getWidth = function (el) {
        var result = DomHelpers.computedStyle(el, 'width');
        return parseInt(result);
    };
    return DomHelpers;
}());

var MappingHelpers = /** @class */ (function () {
    function MappingHelpers() {
    }
    /**
     * A bit weird function.
     * Gonna explain the case.
     * I have main object and auxiliary object.
     * Main object might look like this: {id: 5}, or be null.
     * Auxiliary object might look like this {id: 5} or like this {id: undefined}
     * And what we try to do is get the best looking object out of this arrangement.
     * We start from main, then go to auxiliary. If auxiliary object has empty spots
     * we default to null.
     * This is useful when object arrives at some point as {data_one: 1, data_two: 2}
     * and at other point as {data: {one: 1, two: 2}}. And we need to accommodate both
     * cases into one.
     */
    MappingHelpers.mapMerge = function (main, auxiliary) {
        if (auxiliary === void 0) { auxiliary = {}; }
        if (main) {
            return main;
        }
        // If has filled fields.
        if (Object.keys(auxiliary).some(function (index) { return auxiliary[index]; })) {
            return auxiliary;
        }
        return null;
    };
    /**
     * @see mapMerge
     * Also applies type if value is not empty.
     */
    MappingHelpers.mapWithType = function (main, auxiliary, Type) {
        if (auxiliary === void 0) { auxiliary = {}; }
        var result = MappingHelpers.mapMerge(main, auxiliary);
        return result ? new Type(result) : null;
    };
    /**
     * @see mapMerge
     * Runs closure if value is not empty.
     */
    MappingHelpers.mapWithClosure = function (main, auxiliary, closure) {
        if (auxiliary === void 0) { auxiliary = {}; }
        var result = MappingHelpers.mapMerge(main, auxiliary);
        return result ? closure(result) : null;
    };
    /**
     * Fix parameters with incorrect ids.
     * Works only for number ids. Also won't override existing values.
     * Example:
     * Before: {user_id: 5}
     * After: {user: {id: 5}}
     */
    MappingHelpers.fixIds = function (data) {
        ObjectHelpers.traverse(data, function (node) {
            for (var key in node) {
                var property = node[key];
                if (property && typeof property === 'object') {
                    continue;
                }
                var matches = /(.+)_id$/g.exec(key);
                if (matches && (typeof property === 'number')) {
                    var entityName = matches[1];
                    if (!node[entityName]) {
                        node[entityName] = { id: property };
                    }
                    delete node[key];
                }
            }
        });
    };
    MappingHelpers.isIdObject = function (object) {
        var keys = Object.keys(object);
        return keys.length === 1 &&
            keys[0] === 'id' &&
            (typeof object['id'] === 'number');
    };
    /**
     * Exact opposite of fixIds.
     * Example:
     * Before: {user: {id: 5}}
     * After: {user: {id: 5}, user_id: 5}
     */
    MappingHelpers.unfixIds = function (data) {
        ObjectHelpers.traverse(data, function (node) {
            for (var key in node) {
                var property = node[key];
                if ((!property) || (typeof property !== 'object') || (typeof property.id !== 'number')) {
                    continue;
                }
                node[(key + '_id')] = property.id;
            }
        });
    };
    /**
     * Fill objects from one tree to another.
     */
    MappingHelpers.hydrateTree = function (from, to, type) {
        ObjectHelpers.traverseBranches(to, function (toItem, parent, index) {
            // Check if item is getter. Ignore it if so.
            if (parent) {
                var descriptor = Object.getOwnPropertyDescriptor(parent, index);
                if (!descriptor) {
                    return;
                }
            }
            if (!(toItem instanceof type)) {
                return; // continue
            }
            ObjectHelpers.traverseBranches(from, function (fromItem) {
                if (!(fromItem instanceof type) || toItem.id !== fromItem.id) {
                    return;
                }
                parent[index] = fromItem;
                return true; // break
            });
        });
    };
    return MappingHelpers;
}());

var MathHelpers = /** @class */ (function () {
    function MathHelpers() {
    }
    /**
     * Like Math.floor but directed towards zero, and not negative infinity.
     */
    MathHelpers.truncate = function (number) {
        return number < 0 ? Math.ceil(number) : Math.floor(number);
    };
    return MathHelpers;
}());

var StringHelpers = /** @class */ (function () {
    function StringHelpers() {
    }
    StringHelpers.truncate = function (text, maxChars) {
        if (!text) {
            return '';
        }
        return text.length <= maxChars ? text : text.substring(0, maxChars) + '...';
    };
    StringHelpers.toKebabCase = function (text) {
        return text.replace(/([a-z])([A-Z])/g, '$1-$2')
            .replace(/(\s+|_)/g, '-')
            .toLowerCase();
    };
    StringHelpers.toCamelCase = function (text) {
        return text
            .replace(/(\s|_)(.)/g, function ($1) {
            return $1.toUpperCase();
        })
            .replace(/\s|_/g, '')
            .replace(/^(.)/, function ($1) {
            return $1.toLowerCase();
        });
    };
    StringHelpers.toPascalCase = function (text) {
        return text
            .replace(/(\s|_|-)(.)/g, function ($1) {
            return $1.toUpperCase();
        })
            .replace(/\s|_|-/g, '')
            .replace(/^(.)/, function ($1) {
            return $1.toUpperCase();
        });
    };
    return StringHelpers;
}());




/***/ }),

/***/ "../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=script&lang=js&":
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/babel-loader/lib!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=script&lang=js& ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @fortawesome/vue-fontawesome */ "../../node_modules/@fortawesome/vue-fontawesome/index.es.js");
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'com-button-icon',
  components: {
    FontAwesomeIcon: _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_0__["FontAwesomeIcon"]
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: false
    }
  }
});

/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./src/scss/app.scss":
/*!**********************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!./src/scss/app.scss ***!
  \**********************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".demo-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start; }\n  .demo-container__item {\n    margin: 5px;\n    padding: 20px;\n    background-color: white; }\n  .demo-container__header {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    margin: -20px -20px 20px;\n    padding: 10px;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .demo-container__footer {\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    margin: 20px -20px -20px;\n    padding: 20px; }\n  .demo-container__separator {\n    width: 100%;\n    height: 20px; }\n  .demo-container__colored-block {\n    min-width: 30px;\n    min-height: 30px;\n    background-color: #e7dfb0; }\n  .demo-container__dotted-wrapper {\n    border: dotted .5px #4b4b4b;\n    display: table; }\n    .demo-container__dotted-wrapper + .demo-container__dotted-wrapper {\n      margin-top: 20px; }\n  .demo-container--error {\n    color: white;\n    font-size: 16px;\n    background-color: #ff7761; }\n  .demo-container--config {\n    color: #212121;\n    margin: 5px;\n    border: solid 2px red;\n    padding: 20px;\n    background-color: #d8e2f7; }\n  .demo-container--operable {\n    background-color: #ddfcdc; }\n  .demo-container--status {\n    background-color: #b8c8f7; }\n  .demo-container--darkened {\n    background-color: #eaeaea; }\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss&":
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss& ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".com-button-icon {\n  cursor: pointer;\n  display: inline-flex;\n  border-radius: 3px;\n  padding: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #3f506e;\n}\n.com-button-icon--active {\n    padding: 2px;\n    border: #1fc8db solid 1px;\n    background-color: #c7d6e1;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss&":
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss& ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".vue-book-input {\n  border-radius: 3px;\n  border: none;\n  padding: 4px 24px 4px 5px;\n  width: 100%;\n}\n.vue-book-input:focus::placeholder {\n    opacity: 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss&":
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss& ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".vue-book-menu {\n  display: flex;\n}\n.vue-book-menu__filler {\n    flex: 1 0;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss&":
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss& ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".VueBookRoot {\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  display: flex;\n  top: 0;\n  left: 0;\n}\n.VueBookRoot__menu {\n    padding: 5px;\n}\n.VueBookRoot__menu__search {\n      position: relative;\n      margin-top: 5px;\n}\n.VueBookRoot__menu__search__icon {\n        position: absolute;\n        right: 6px;\n        top: 3px;\n        color: #3f506e;\n        cursor: pointer;\n        opacity: 0.3;\n}\n.VueBookRoot__search-input {\n    background-color: #fbfefe;\n    margin-bottom: 5px;\n    border-radius: 4px;\n}\n.VueBookRoot__files {\n    background-color: #1fc8db;\n    padding: 0 5px 5px 5px;\n    flex: 1 0;\n    height: 300px;\n}\n.VueBookRoot__left-block {\n    font-family: \"Noto Sans\", sans-serif;\n    position: relative;\n    background-color: #1fc8db;\n    height: 100%;\n    flex: 0 0;\n    display: flex;\n    flex-direction: column;\n}\n.VueBookRoot__left-block__resize-line {\n      position: absolute;\n      right: 0;\n      top: 0;\n      bottom: 0;\n}\n.VueBookRoot__left-block * {\n      box-sizing: border-box;\n}\n.VueBookRoot__right-block {\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    height: 100%;\n}\n.VueBookRoot__right-block .VueBookRoot__component {\n      overflow: auto;\n      flex: auto;\n      padding: 10px;\n      width: 100%;\n      height: 100%;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss&":
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss& ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".VbCard {\n  margin: 5px;\n  background-color: white;\n  padding: 20px;\n}\n.VbCard--dark {\n    background-color: #252525;\n}\n.VbCard--dark .VbCard__title {\n      color: #ededed;\n      background-color: #252525;\n}\n.VbCard--dark .VbCard__separator {\n      background-color: #9d9d9d;\n}\n.VbCard--dark.VbCard--dashed {\n      border: dashed #d0daee 1px;\n}\n.VbCard__title {\n    background-color: white;\n    display: flex;\n    margin: -20px -20px 0;\n    padding: 3px 5px;\n    align-items: center;\n}\n.VbCard.VbCard--no-padding .VbCard__title {\n      margin: 0;\n}\n.VbCard__title__text {\n      font-weight: 700;\n}\n.VbCard__title__spacer {\n      flex: 1 0;\n}\n.VbCard__title__icon {\n      margin-left: 4px;\n      font-size: 14px;\n      padding: 2px;\n      user-select: none;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n}\n.VbCard__title__icon:hover {\n        color: gray;\n}\n.VbCard__separator {\n    height: 1px;\n    background-color: rgba(0, 0, 0, 0.2);\n    margin: 0 -20px 20px;\n}\n.VbCard.VbCard--no-padding .VbCard__separator {\n      margin: 0;\n}\n.VbCard--no-padding {\n    padding: 0;\n}\n.VbCard--dashed {\n    border: dashed #7c8391 1px;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss&":
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss& ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".VbDemo {\n  height: 100%;\n  overflow: auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  align-content: flex-start;\n  background-color: #eeeeee;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss&":
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss& ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".book-component-list-folder__header {\n  cursor: pointer;\n  display: flex;\n}\n.book-component-list-folder__header__caret {\n    flex: 0 0 14px;\n    width: 14px;\n    width: 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.book-component-list-folder__header__icon {\n    flex: 0 0 18px;\n    height: 18px;\n    width: 18px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #656192;\n    margin-left: 3px;\n    margin-right: 3px;\n}\n.book-component-list-folder__insides {\n  padding-left: 16px;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss&":
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss& ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".BookComponentListItem {\n  padding-top: 2px;\n  padding-bottom: 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  color: black;\n  white-space: nowrap;\n  display: block;\n}\n.BookComponentListItem.BookComponentListItem--active {\n    background-color: #0f626b;\n}\n.BookComponentListItem.BookComponentListItem--active .BookComponentListItem__file-name {\n    color: #e4f9fb;\n}\n.BookComponentListItem__icon {\n    color: #829268;\n    margin-left: 3px;\n    margin-right: 3px;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss&":
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss& ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".DemoFileList {\n  height: 100%;\n  background-color: white;\n  overflow: auto;\n}\n.DemoFileList__node--pre-selected {\n    background-color: #1fc8db;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss&":
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss& ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".TreeDemoFileList {\n  height: 100%;\n  background-color: white;\n  overflow: auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss&":
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss& ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(/*! ../../../../../node_modules/css-loader/lib/css-base.js */ "../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".vue-book-resize-line {\n  width: 4px;\n  cursor: col-resize;\n}\n.vue-book-resize-line--is-horizontal {\n    cursor: row-resize;\n}\n", ""]);

// exports


/***/ }),

/***/ "../../node_modules/css-loader/lib/css-base.js":
/*!*******************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader/lib/css-base.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "../../node_modules/process/browser.js":
/*!***********************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/process/browser.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/setimmediate/setImmediate.js":
/*!*********************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/setimmediate/setImmediate.js ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "../../node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss&":
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss& ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../../node_modules/css-loader!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/sass-loader/lib/loader.js!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./ComButtonIcon.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss&":
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss& ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../../node_modules/css-loader!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/sass-loader/lib/loader.js!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookInput.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss&":
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss& ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookMenu.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss&":
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss& ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookRoot.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss&":
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss& ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbCard.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss&":
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss& ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbDemo.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss&":
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss& ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListFolder.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss&":
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss& ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListItem.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss&":
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss& ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./DemoFileList.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss&":
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss& ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./TreeDemoFileList.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss&":
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/css-loader!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/stylePostLoader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/sass-loader/lib/loader.js!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss& ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookResizeLine.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss&");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "../../node_modules/style-loader/lib/addStyles.js":
/*!**********************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader/lib/addStyles.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(/*! ./urls */ "../../node_modules/style-loader/lib/urls.js");

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "../../node_modules/style-loader/lib/urls.js":
/*!*****************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/style-loader/lib/urls.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ "../../node_modules/timers-browserify/main.js":
/*!******************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/timers-browserify/main.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ "../../node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=script&lang=ts&":
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=script&lang=ts& ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// input: HTMLInputElement
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'vue-book-input',
    data() {
        return {
            temporaryValue: '',
        };
    },
    props: {
        type: {
            type: String,
            default: 'default',
        },
        name: {
            type: String,
            default: 'default',
        },
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        tooltip: {
            type: String,
            default: '',
        },
    },
    methods: {
        focus() {
            this.$el.focus();
        }
    },
    computed: {
        valueProxy: {
            get() {
                if (this.value !== this.temporaryValue) {
                    this.temporaryValue = this.value;
                }
                return this.temporaryValue;
            },
            set(value) {
                this.temporaryValue = value;
                this.$nextTick(() => {
                    if (this.value !== this.temporaryValue) {
                        this.temporaryValue = this.value;
                    }
                });
                this.$emit('input', value);
            },
        },
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=script&lang=ts&":
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookMenu.vue?vue&type=script&lang=ts& ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _DemoPageConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DemoPageConfig */ "./src/components/DemoPage/DemoPageConfig.ts");
/* harmony import */ var _classes_Main_TreeFile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../classes/Main/TreeFile */ "./src/classes/Main/TreeFile.ts");
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @fortawesome/vue-fontawesome */ "../../node_modules/@fortawesome/vue-fontawesome/index.es.js");
/* harmony import */ var _ComButtonIcon_ComButtonIcon_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ComButtonIcon/ComButtonIcon.vue */ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue");




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'vue-book-menu',
    components: {
        ComButtonIcon: _ComButtonIcon_ComButtonIcon_vue__WEBPACK_IMPORTED_MODULE_3__["default"],
        FontAwesomeIcon: _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_2__["FontAwesomeIcon"],
    },
    props: {
        currentFile: {
            type: _classes_Main_TreeFile__WEBPACK_IMPORTED_MODULE_1__["TreeFile"],
            required: false,
        },
        config: {
            type: _DemoPageConfig__WEBPACK_IMPORTED_MODULE_0__["default"],
            required: true,
        },
    },
    computed: {
        DemoPageMode: () => _DemoPageConfig__WEBPACK_IMPORTED_MODULE_0__["DemoPageMode"],
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=script&lang=ts&":
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookRoot.vue?vue&type=script&lang=ts& ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _store_FoldersStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../store/FoldersStore */ "./src/store/FoldersStore.ts");
/* harmony import */ var _store_configStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../store/configStore */ "./src/store/configStore.ts");
/* harmony import */ var _FileTree_BookComponentListFolder_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../FileTree/BookComponentListFolder.vue */ "./src/components/FileTree/BookComponentListFolder.vue");
/* harmony import */ var _FileTree_BookComponentListItem_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../FileTree/BookComponentListItem.vue */ "./src/components/FileTree/BookComponentListItem.vue");
/* harmony import */ var _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../classes/Main/TreeFolder */ "./src/classes/Main/TreeFolder.ts");
/* harmony import */ var _FileTree_DemoFileList_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../FileTree/DemoFileList.vue */ "./src/components/FileTree/DemoFileList.vue");
/* harmony import */ var _Service_VueBookResizeLine_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Service/VueBookResizeLine.vue */ "./src/components/Service/VueBookResizeLine.vue");
/* harmony import */ var _DemoPageConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./DemoPageConfig */ "./src/components/DemoPage/DemoPageConfig.ts");
/* harmony import */ var _VueBookMenu_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./VueBookMenu.vue */ "./src/components/DemoPage/VueBookMenu.vue");
/* harmony import */ var _ComInput_VueBookInput_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./ComInput/VueBookInput.vue */ "./src/components/DemoPage/ComInput/VueBookInput.vue");
/* harmony import */ var _FileTree_TreeDemoFileList_vue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../FileTree/TreeDemoFileList.vue */ "./src/components/FileTree/TreeDemoFileList.vue");
/* harmony import */ var _FileTree_ListCursor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../FileTree/ListCursor */ "./src/components/FileTree/ListCursor.ts");
/* harmony import */ var _classes_Main_TreeFileCollection__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../classes/Main/TreeFileCollection */ "./src/classes/Main/TreeFileCollection.ts");
/* harmony import */ var _VueBookTreeOptions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./VueBookTreeOptions */ "./src/components/DemoPage/VueBookTreeOptions.ts");
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @fortawesome/vue-fontawesome */ "../../node_modules/@fortawesome/vue-fontawesome/index.es.js");
/* harmony import */ var _Exposed_ContainerFocusService__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../Exposed/ContainerFocusService */ "./src/components/Exposed/ContainerFocusService.ts");
















let lastUpdateTimestamp = 0;
const hasInFilename = (searchText, treeFile) => {
    return treeFile.getFilename().toUpperCase().includes(searchText);
};
const sortByRelevance = (searchText, treeFiles) => {
    return treeFiles.sort((a, b) => {
        const search = searchText.toUpperCase();
        // Files that have a search in their filename are sent to the top.
        if (hasInFilename(search, a) && !hasInFilename(search, b)) {
            return -1;
        }
        if (hasInFilename(search, b) && !hasInFilename(search, a)) {
            return 1;
        }
        return 0;
    });
};
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueBookRoot',
    mixins: [
        _Exposed_ContainerFocusService__WEBPACK_IMPORTED_MODULE_15__["ContainerFocusProvideMixin"],
    ],
    components: {
        TreeDemoFileList: _FileTree_TreeDemoFileList_vue__WEBPACK_IMPORTED_MODULE_10__["default"],
        VueBookInput: _ComInput_VueBookInput_vue__WEBPACK_IMPORTED_MODULE_9__["default"],
        VueBookMenu: _VueBookMenu_vue__WEBPACK_IMPORTED_MODULE_8__["default"],
        VueBookResizeLine: _Service_VueBookResizeLine_vue__WEBPACK_IMPORTED_MODULE_6__["default"],
        DemoFileList: _FileTree_DemoFileList_vue__WEBPACK_IMPORTED_MODULE_5__["default"],
        BookComponentListFolder: _FileTree_BookComponentListFolder_vue__WEBPACK_IMPORTED_MODULE_2__["default"],
        BookComponentListItem: _FileTree_BookComponentListItem_vue__WEBPACK_IMPORTED_MODULE_3__["default"],
        FontAwesomeIcon: _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_14__["FontAwesomeIcon"],
    },
    data() {
        return {
            treeFolder: null,
            listCursor: new _FileTree_ListCursor__WEBPACK_IMPORTED_MODULE_11__["ListCursor"](),
            configStore: new _store_configStore__WEBPACK_IMPORTED_MODULE_1__["ConfigStore"](),
            foldersStoreInstance: new _store_FoldersStore__WEBPACK_IMPORTED_MODULE_0__["FoldersStore"](),
            vueBookTreeOptions: new _VueBookTreeOptions__WEBPACK_IMPORTED_MODULE_13__["VueBookTreeOptions"]({
                noRouter: this.getNoRouter(),
                selectedTreeFile: null,
                hideFileExtensions: this.getHideFileExtensions(),
            }),
        };
    },
    props: {
        treeFolderDefault: {
            type: _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_4__["TreeFolder"],
        },
        treeFileCollectionDefault: {
            type: _classes_Main_TreeFileCollection__WEBPACK_IMPORTED_MODULE_12__["TreeFileCollection"],
        },
        hideFileExtensionsDefault: {
            type: Boolean,
            default: false,
        },
        hideNavigationDefault: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        const input = this.$refs.searchInput;
        input && input.$el.focus();
    },
    created() {
        this.foldersStoreInstance.load();
        this.configStore.load();
        const treeFolder = this.getDemoFolder();
        treeFolder.mergeWithFolders(this.foldersStoreInstance.openFolders);
        this.treeFolder = treeFolder;
    },
    watch: {
        'config': {
            handler(value) {
                if (lastUpdateTimestamp < Math.floor(Date.now()) - 200) {
                    this.configStore.config = value;
                    this.configStore.save();
                    lastUpdateTimestamp = Math.floor(Date.now());
                }
            },
            deep: true,
        },
        'treeFolder': {
            handler(value) {
                this.foldersStoreInstance.openFolders = value.getOpenFolders();
                this.foldersStoreInstance.save();
            },
            deep: true,
        },
    },
    provide() {
        return {
            [_VueBookTreeOptions__WEBPACK_IMPORTED_MODULE_13__["VueBookTreeOptionsInterface"]]: this.vueBookTreeOptions,
        };
    },
    computed: {
        DemoPageMode: () => _DemoPageConfig__WEBPACK_IMPORTED_MODULE_7__["DemoPageMode"],
        noRouter() {
            return this.getNoRouter();
        },
        hideFileExtensions() {
            return this.getHideFileExtensions();
        },
        config() {
            return this.configStore.config;
        },
        component() {
            return this.currentFile && this.currentFile.component;
        },
        currentFile() {
            if (this.noRouter) {
                return this.vueBookTreeOptions.selectedTreeFile;
            }
            return this.files.find((file) => {
                return this.$route.path === file.path;
            }) || null;
        },
        files() {
            return this.treeFileCollection.treeFiles;
        },
        treeFileCollection() {
            let treeFileCollection = this.treeFileCollectionDefault;
            if (!treeFileCollection) {
                treeFileCollection = this.$route.meta.treeFileCollection;
            }
            if (!(treeFileCollection instanceof _classes_Main_TreeFileCollection__WEBPACK_IMPORTED_MODULE_12__["TreeFileCollection"])) {
                throw new Error('No treeFileCollection found: pass it to props or provide via route meta');
            }
            return treeFileCollection;
        },
        filteredFiles() {
            if (!this.config.searchText) {
                return this.files;
            }
            const treeFiles = this.files.filter((file) => this.fileSelected(file));
            return sortByRelevance(this.config.searchText, treeFiles);
        },
    },
    methods: {
        clearSearch() {
            this.config.searchText = '';
            this.$refs.searchInput.focus();
        },
        getNoRouter() {
            return !!(this.treeFolderDefault && this.treeFileCollectionDefault);
        },
        getHideFileExtensions() {
            if (this.noRouter) {
                return this.hideFileExtensionsDefault;
            }
            return this.$route.meta.hideFileExtensions;
        },
        getHideNavigation() {
            if (this.noRouter) {
                return this.hideNavigationDefault;
            }
            return this.$route.meta.hideNavigation;
        },
        getDemoFolder() {
            let treeFolder = this.treeFolderDefault;
            if (!treeFolder) {
                treeFolder = this.$route.meta.treeFolder;
            }
            if (!(treeFolder instanceof _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_4__["TreeFolder"])) {
                throw new Error('No treeFolder found: pass it to props or provide via route meta');
            }
            return treeFolder;
        },
        fileSelected(file) {
            if (this.noRouter) {
                return this.vueBookTreeOptions.selectedTreeFile === file;
            }
            const path = file.path.toUpperCase();
            const text = this.config.searchText.toUpperCase();
            const includesFull = path.includes(text);
            if (includesFull) {
                return includesFull;
            }
            const upperCaseLetters = file.getFilename().replace(/[a-z.]/g, '');
            return upperCaseLetters.includes(this.config.searchText);
        },
        moveCursor(delta) {
            const files = this.filteredFiles;
            if (!this.listCursor.preSelectedItem) {
                this.listCursor.preSelectedItem = files[0];
                return;
            }
            const fileIndex = files.indexOf(this.listCursor.preSelectedItem);
            if (fileIndex === -1) {
                this.listCursor.preSelectedItem = files[0];
                return;
            }
            const nextFileIndex = fileIndex + delta;
            if (nextFileIndex === -1) {
                this.listCursor.preSelectedItem = files[0];
                return;
            }
            if (nextFileIndex === files.length) {
                this.listCursor.preSelectedItem = files[files.length - 1];
                return;
            }
            this.listCursor.preSelectedItem = files[nextFileIndex];
        },
        selectFileUnderCursor() {
            const fileUnderCursor = this.listCursor.preSelectedItem;
            if (!fileUnderCursor) {
                return;
            }
            if (!this.filteredFiles.includes(fileUnderCursor)) {
                return;
            }
            if (this.noRouter) {
                this.vueBookTreeOptions.selectedTreeFile = fileUnderCursor;
                return;
            }
            this.$router.push(fileUnderCursor.path);
        },
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=script&lang=ts&":
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbCard.vue?vue&type=script&lang=ts& ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @fortawesome/vue-fontawesome */ "../../node_modules/@fortawesome/vue-fontawesome/index.es.js");
/* harmony import */ var _ContainerFocusService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ContainerFocusService */ "./src/components/Exposed/ContainerFocusService.ts");


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VbCard',
    components: { FontAwesomeIcon: _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_0__["FontAwesomeIcon"] },
    mixins: [
        _ContainerFocusService__WEBPACK_IMPORTED_MODULE_1__["ContainerFocusInjectMixin"],
    ],
    data: () => ({
        show: true,
        cardStyleTemp: null,
    }),
    props: {
        noPadding: Boolean,
        dashed: Boolean,
        title: String,
        refresh: Boolean,
        dark: Boolean,
        width: String,
        height: String,
        color: String,
    },
    computed: {
        computedStyle() {
            if (this.cardStyleTemp) {
                return {
                    ...this.cardStyleTemp,
                    backgroundColor: this.color,
                };
            }
            return {
                height: this.height,
                width: this.width,
                backgroundColor: this.color,
            };
        },
        computedClass() {
            return {
                'VbCard--no-padding': this.noPadding,
                'VbCard--dashed': this.dashed,
                'VbCard--dark': this.dark,
            };
        },
    },
    methods: {
        doRefresh() {
            const { width, height } = window.getComputedStyle(this.$el);
            this.cardStyleTemp = { width, height };
            this.show = false;
            setTimeout(() => {
                this.cardStyleTemp = null;
                this.show = true;
            });
        },
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=script&lang=ts&":
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbDemo.vue?vue&type=script&lang=ts& ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VbDemo',
    computed: {
        computedClass() {
            return {};
        }
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=script&lang=ts&":
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListFolder.vue?vue&type=script&lang=ts& ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BookComponentListItem_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BookComponentListItem.vue */ "./src/components/FileTree/BookComponentListItem.vue");
/* harmony import */ var _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../classes/Main/TreeFolder */ "./src/classes/Main/TreeFolder.ts");
/* harmony import */ var asva_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! asva-helpers */ "../../node_modules/asva-helpers/dist/src/index.esm.js");
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @fortawesome/vue-fontawesome */ "../../node_modules/@fortawesome/vue-fontawesome/index.es.js");




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'book-component-list-folder',
    components: {
        FontAwesomeIcon: _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_3__["FontAwesomeIcon"],
        vmFile: _BookComponentListItem_vue__WEBPACK_IMPORTED_MODULE_0__["default"],
    },
    props: {
        folder: {
            type: _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_1__["TreeFolder"],
            required: true,
        },
    },
    methods: {
        openSelected() {
            const foldersChain = asva_helpers__WEBPACK_IMPORTED_MODULE_2__["ObjectHelpers"]
                .traverseBranch(this.folder, { path: this.$route.path })
                .filter(item => {
                return (item instanceof _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_1__["TreeFolder"]);
            });
            if (foldersChain.length) {
                this.folder.isOpen = true;
            }
            if (foldersChain.length > 1) {
                setTimeout(() => {
                    const folderComponent = this.$refs.folders.find((folderComponent) => folderComponent.folder === foldersChain[1]);
                    folderComponent && folderComponent.openSelected();
                });
            }
        },
        generateKey() {
            return Math.floor(Math.random() * 1e8);
        },
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=script&lang=ts&":
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListItem.vue?vue&type=script&lang=ts& ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _classes_Main_TreeFile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../classes/Main/TreeFile */ "./src/classes/Main/TreeFile.ts");
/* harmony import */ var _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @fortawesome/vue-fontawesome */ "../../node_modules/@fortawesome/vue-fontawesome/index.es.js");
/* harmony import */ var _DemoPage_VueBookTreeOptions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../DemoPage/VueBookTreeOptions */ "./src/components/DemoPage/VueBookTreeOptions.ts");



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BookComponentListItem',
    components: {
        FontAwesomeIcon: _fortawesome_vue_fontawesome__WEBPACK_IMPORTED_MODULE_1__["FontAwesomeIcon"],
    },
    inject: [
        _DemoPage_VueBookTreeOptions__WEBPACK_IMPORTED_MODULE_2__["VueBookTreeOptionsInterface"],
    ],
    props: {
        file: {
            type: _classes_Main_TreeFile__WEBPACK_IMPORTED_MODULE_0__["TreeFile"],
            required: true,
        },
    },
    computed: {
        vueBookTreeOptions() {
            return this[_DemoPage_VueBookTreeOptions__WEBPACK_IMPORTED_MODULE_2__["VueBookTreeOptionsInterface"]];
        },
        name() {
            if (this.vueBookTreeOptions.hideFileExtensions) {
                return this.file.getFilenameWithoutExtension();
            }
            return this.file.getFilename();
        },
        isActive() {
            if (this.vueBookTreeOptions.noRouter) {
                return this.vueBookTreeOptions.selectedTreeFile === this.file;
            }
            return this.$route.path === this.file.path;
        },
    },
    methods: {
        select() {
            if (this.vueBookTreeOptions.noRouter) {
                this.vueBookTreeOptions.selectedTreeFile = this.file;
                return;
            }
            this.$router.push(this.file.path);
        },
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=script&lang=ts&":
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/DemoFileList.vue?vue&type=script&lang=ts& ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ListCursor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ListCursor */ "./src/components/FileTree/ListCursor.ts");
/* harmony import */ var _BookComponentListItem_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BookComponentListItem.vue */ "./src/components/FileTree/BookComponentListItem.vue");


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'DemoFileList',
    components: {
        BookComponentListItem: _BookComponentListItem_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
    },
    props: {
        listCursor: {
            type: _ListCursor__WEBPACK_IMPORTED_MODULE_0__["ListCursor"],
            required: true,
        },
        files: {
            type: Array,
            required: true,
        },
    },
    methods: {
        filePreSelected(file) {
            return this.listCursor.preSelectedItem === file;
        },
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=script&lang=ts&":
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/TreeDemoFileList.vue?vue&type=script&lang=ts& ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BookComponentListFolder_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BookComponentListFolder.vue */ "./src/components/FileTree/BookComponentListFolder.vue");
/* harmony import */ var _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../classes/Main/TreeFolder */ "./src/classes/Main/TreeFolder.ts");


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'TreeDemoFileList',
    components: { BookComponentListFolder: _BookComponentListFolder_vue__WEBPACK_IMPORTED_MODULE_0__["default"] },
    props: {
        folder: {
            type: _classes_Main_TreeFolder__WEBPACK_IMPORTED_MODULE_1__["TreeFolder"],
            required: true,
        },
    },
});


/***/ }),

/***/ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=script&lang=ts&":
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/ts-loader??ref--3!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Service/VueBookResizeLine.vue?vue&type=script&lang=ts& ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({
    data() {
        return {
            startValue: 0,
            startCoordinate: 0,
        };
    },
    props: {
        value: {
            type: Number,
            required: true,
        },
        isHorizontal: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onDrag(event) {
            // No idea how, but this works.
            if (this.isHorizontal) {
                if (event.screenY) {
                    const totalHeight = document.documentElement.clientHeight;
                    this.$emit('input', totalHeight - (event.clientY));
                }
                return;
            }
            if (event.screenX) {
                this.$emit('input', event.clientX);
            }
        },
    },
});


/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=template&id=5aadf9fc&":
/*!******************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=template&id=5aadf9fc& ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "com-button-icon",
      class: { "com-button-icon--active": _vm.active }
    },
    [_c("font-awesome-icon", { attrs: { icon: _vm.icon } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=template&id=62416c18&":
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=template&id=62416c18& ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "checkbox"
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valueProxy,
            expression: "valueProxy"
          }
        ],
        staticClass: "vue-book-input",
        attrs: {
          name: _vm.name,
          placeholder: _vm.placeholder,
          autocomplete: "off",
          type: "checkbox"
        },
        domProps: {
          checked: Array.isArray(_vm.valueProxy)
            ? _vm._i(_vm.valueProxy, null) > -1
            : _vm.valueProxy
        },
        on: {
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.$emit("up")
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.$emit("down")
            }
          ],
          keypress: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("enter")
          },
          focus: function($event) {
            return _vm.$emit("focus")
          },
          blur: function($event) {
            return _vm.$emit("blur")
          },
          change: function($event) {
            var $$a = _vm.valueProxy,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.valueProxy = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.valueProxy = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.valueProxy = $$c
            }
          }
        }
      })
    : _vm.type === "radio"
    ? _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valueProxy,
            expression: "valueProxy"
          }
        ],
        staticClass: "vue-book-input",
        attrs: {
          name: _vm.name,
          placeholder: _vm.placeholder,
          autocomplete: "off",
          type: "radio"
        },
        domProps: { checked: _vm._q(_vm.valueProxy, null) },
        on: {
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.$emit("up")
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.$emit("down")
            }
          ],
          keypress: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("enter")
          },
          focus: function($event) {
            return _vm.$emit("focus")
          },
          blur: function($event) {
            return _vm.$emit("blur")
          },
          change: function($event) {
            _vm.valueProxy = null
          }
        }
      })
    : _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.valueProxy,
            expression: "valueProxy"
          }
        ],
        staticClass: "vue-book-input",
        attrs: {
          name: _vm.name,
          placeholder: _vm.placeholder,
          autocomplete: "off",
          type: _vm.type
        },
        domProps: { value: _vm.valueProxy },
        on: {
          keydown: [
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.$emit("up")
            },
            function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown"
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.$emit("down")
            }
          ],
          keypress: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("enter")
          },
          focus: function($event) {
            return _vm.$emit("focus")
          },
          blur: function($event) {
            return _vm.$emit("blur")
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.valueProxy = $event.target.value
          }
        }
      })
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=template&id=a008a0be&":
/*!**************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookMenu.vue?vue&type=template&id=a008a0be& ***!
  \**************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-book-menu" },
    [
      _c("com-button-icon", {
        staticClass: "vue-book-menu__icon",
        attrs: {
          title: "Mode: Tree",
          icon: "server",
          active: _vm.config.mode === _vm.DemoPageMode.Tree
        },
        nativeOn: {
          click: function($event) {
            _vm.config.mode = _vm.DemoPageMode.Tree
          }
        }
      }),
      _vm._v(" "),
      _c("com-button-icon", {
        staticClass: "vue-book-menu__icon",
        attrs: {
          title: "Mode: Search",
          icon: "search",
          active: _vm.config.mode === _vm.DemoPageMode.Search
        },
        nativeOn: {
          click: function($event) {
            _vm.config.mode = _vm.DemoPageMode.Search
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "vue-book-menu__filler" }),
      _vm._v(" "),
      _vm.config.mode === _vm.DemoPageMode.Tree
        ? [
            _vm.currentFile
              ? _c("com-button-icon", {
                  staticClass: "vue-book-menu__icon",
                  attrs: {
                    title: "Expand from Current File",
                    icon: "dot-circle"
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.$emit("openFolder")
                    }
                  }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=template&id=6bf2bcb8&":
/*!**************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/DemoPage/VueBookRoot.vue?vue&type=template&id=6bf2bcb8& ***!
  \**************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "VueBookRoot" }, [
    !_vm.files.length
      ? _c("div", [
          _c("p", [_vm._v("You provided no files in requireContext.")]),
          _vm._v(" "),
          _c("p", [_vm._v("Please check your path and masks.")])
        ])
      : !_vm.getHideNavigation()
      ? _c(
          "div",
          {
            staticClass: "VueBookRoot__left-block",
            style: {
              "flex-basis": _vm.config.width + "px",
              width: _vm.config.width + "px"
            }
          },
          [
            _c(
              "div",
              { staticClass: "VueBookRoot__menu" },
              [
                _c("vue-book-menu", {
                  attrs: { config: _vm.config, currentFile: _vm.currentFile },
                  on: {
                    openFolder: function($event) {
                      return _vm.currentFile.openFolder()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.config.mode === _vm.DemoPageMode.Search
                  ? _c(
                      "div",
                      { staticClass: "VueBookRoot__menu__search" },
                      [
                        _c("vue-book-input", {
                          ref: "searchInput",
                          staticClass: "VueBookRoot__search-input",
                          attrs: { placeholder: "Search..." },
                          on: {
                            up: function($event) {
                              return _vm.moveCursor(-1)
                            },
                            down: function($event) {
                              return _vm.moveCursor(1)
                            },
                            enter: function($event) {
                              return _vm.selectFileUnderCursor()
                            },
                            blur: function($event) {
                              return _vm.listCursor.clean()
                            }
                          },
                          model: {
                            value: _vm.config.searchText,
                            callback: function($$v) {
                              _vm.$set(_vm.config, "searchText", $$v)
                            },
                            expression: "config.searchText"
                          }
                        }),
                        _vm._v(" "),
                        _vm.config.searchText
                          ? _c(
                              "div",
                              {
                                staticClass: "VueBookRoot__menu__search__icon",
                                on: {
                                  click: function($event) {
                                    return _vm.clearSearch()
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "times" }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "VueBookRoot__files" },
              [
                _vm.config.mode === _vm.DemoPageMode.Search
                  ? [
                      !_vm.filteredFiles.length
                        ? [
                            _vm._v(
                              "\n          No files found according to search.\n        "
                            )
                          ]
                        : _c("DemoFileList", {
                            attrs: {
                              files: _vm.filteredFiles,
                              listCursor: _vm.listCursor
                            }
                          })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.config.mode === _vm.DemoPageMode.Tree
                  ? _c("tree-demo-file-list", {
                      attrs: {
                        folder: _vm.treeFolder,
                        listCursor: _vm.listCursor
                      }
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c("vue-book-resize-line", {
              staticClass: "VueBookRoot__left-block__resize-line",
              model: {
                value: _vm.config.width,
                callback: function($$v) {
                  _vm.$set(_vm.config, "width", $$v)
                },
                expression: "config.width"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "VueBookRoot__right-block" },
      [_vm.component ? _c(_vm.component, { tag: "component" }) : _vm._e()],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=template&id=2c0fdc7b&":
/*!********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbCard.vue?vue&type=template&id=2c0fdc7b& ***!
  \********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isHiddenAsUnfocused
    ? _c(
        "div",
        {
          staticClass: "VbCard",
          class: _vm.computedClass,
          style: _vm.computedStyle
        },
        [
          _vm.title || _vm.refresh
            ? [
                _c("div", { staticClass: "VbCard__title" }, [
                  _vm.title
                    ? _c("div", { staticClass: "VbCard__title__text" }, [
                        _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "VbCard__title__spacer" }),
                  _vm._v(" "),
                  _vm.focus
                    ? _c(
                        "div",
                        {
                          staticClass: "VbCard__title__icon",
                          staticStyle: {
                            "font-weight": "700",
                            color: "white",
                            "background-color": "#d8365d",
                            "border-radius": "16px",
                            width: "16px"
                          },
                          attrs: {
                            title:
                              "This card is focused. Not focused cards won't be displayed"
                          }
                        },
                        [_c("span", [_vm._v("F")])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.refresh
                    ? _c(
                        "div",
                        {
                          staticClass: "VbCard__title__icon",
                          staticStyle: { cursor: "pointer" },
                          attrs: { title: "Refresh" },
                          on: {
                            click: function($event) {
                              return _vm.doRefresh()
                            }
                          }
                        },
                        [
                          _c("FontAwesomeIcon", {
                            attrs: { title: "Refresh", icon: "sync" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "VbCard__separator" })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.show ? _vm._t("default") : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=template&id=5f9cbdce&":
/*!********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Exposed/VbDemo.vue?vue&type=template&id=5f9cbdce& ***!
  \********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "VbDemo", class: _vm.computedClass },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=template&id=732c849b&":
/*!**************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListFolder.vue?vue&type=template&id=732c849b& ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "book-component-list-folder" }, [
    _c(
      "div",
      {
        staticClass: "book-component-list-folder__header",
        on: {
          click: function($event) {
            return _vm.folder.toggle()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "book-component-list-folder__header__caret" },
          [
            _vm.folder.isOpen
              ? _c("font-awesome-icon", { attrs: { icon: "caret-down" } })
              : _c("font-awesome-icon", { attrs: { icon: "caret-right" } })
          ],
          1
        ),
        _vm._v(" "),
        _c("font-awesome-icon", {
          staticClass: "book-component-list-folder__header__icon",
          attrs: { icon: "folder" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "book-component-list-folder__title" }, [
          _c("span", [_vm._v(_vm._s(_vm.folder.name))])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.folder.isOpen && !_vm.folder.isEmpty()
      ? _c(
          "div",
          { staticClass: "book-component-list-folder__insides" },
          [
            _vm._l(_vm.folder.folders, function(child) {
              return _c("book-component-list-folder", {
                key: _vm.generateKey(),
                ref: "folders",
                refInFor: true,
                attrs: { folder: child }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.folder.files, function(file) {
              return _c("vm-file", {
                key: _vm.generateKey(),
                attrs: { file: file }
              })
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=template&id=1bef2a00&":
/*!************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/BookComponentListItem.vue?vue&type=template&id=1bef2a00& ***!
  \************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "BookComponentListItem",
      class: _vm.isActive && "BookComponentListItem--active",
      attrs: { tag: "div" },
      on: {
        click: function($event) {
          return _vm.select()
        }
      }
    },
    [
      _c("font-awesome-icon", {
        staticClass: "BookComponentListItem__icon",
        attrs: { icon: "file" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "BookComponentListItem__file-name" }, [
        _vm._v("\n    " + _vm._s(_vm.name) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=template&id=2bfa6312&":
/*!***************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/DemoFileList.vue?vue&type=template&id=2bfa6312& ***!
  \***************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "DemoFileList" },
    _vm._l(_vm.files, function(file) {
      return _c(
        "div",
        {
          key: file.path,
          staticClass: "DemoFileList__node",
          class: {
            "DemoFileList__node--pre-selected": _vm.filePreSelected(file)
          },
          on: {
            click: function($event) {
              return _vm.$emit("selected")
            }
          }
        },
        [_c("BookComponentListItem", { attrs: { file: file } })],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=template&id=abe00f60&":
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/FileTree/TreeDemoFileList.vue?vue&type=template&id=abe00f60& ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "TreeDemoFileList" },
    [_c("BookComponentListFolder", { attrs: { folder: _vm.folder } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=template&id=4f11aa3d&":
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib??vue-loader-options!./src/components/Service/VueBookResizeLine.vue?vue&type=template&id=4f11aa3d& ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return staticRenderFns; });
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "vue-book-resize-line",
    class: { "vue-book-resize-line--is-horizontal": _vm.isHorizontal },
    attrs: { draggable: "" },
    on: { drag: _vm.onDrag }
  })
}
var staticRenderFns = []
render._withStripped = true



/***/ }),

/***/ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js":
/*!**************************************************************************************************!*\
  !*** C:/2-Projects/1-asva/5-vue-book/node_modules/vue-loader/lib/runtime/componentNormalizer.js ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "../../node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/*! exports provided: VueBookComponents, createRoute, createComponent, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VueBookComponents", function() { return VueBookComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRoute", function() { return createRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createComponent", function() { return createComponent; });
/* harmony import */ var _classes_Main_VueBookRouteFactory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes/Main/VueBookRouteFactory */ "./src/classes/Main/VueBookRouteFactory.ts");
/* harmony import */ var _scss_app_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./scss/app.scss */ "./src/scss/app.scss");
/* harmony import */ var _scss_app_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_scss_app_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _font_awesome_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./font-awesome-config */ "./src/font-awesome-config.ts");
/* harmony import */ var _classes_Main_VueBookConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./classes/Main/VueBookConfig */ "./src/classes/Main/VueBookConfig.ts");
/* harmony import */ var _components_Exposed_VbDemo_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/Exposed/VbDemo.vue */ "./src/components/Exposed/VbDemo.vue");
/* harmony import */ var _components_Exposed_VbCard_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/Exposed/VbCard.vue */ "./src/components/Exposed/VbCard.vue");






const VueBookComponents = {
    install: (Vue) => {
        Vue.component('VbDemo', _components_Exposed_VbDemo_vue__WEBPACK_IMPORTED_MODULE_4__["default"]);
        Vue.component('VbCard', _components_Exposed_VbCard_vue__WEBPACK_IMPORTED_MODULE_5__["default"]);
        Vue.prototype.$vb = {
            log: (message, ...optionalParams) => {
                // eslint-disable-next-line no-console
                console.log(message, ...optionalParams);
            },
            alert: (message) => {
                alert(message);
            },
        };
    },
};
const createRoute = (options) => _classes_Main_VueBookRouteFactory__WEBPACK_IMPORTED_MODULE_0__["default"].createRoute(new _classes_Main_VueBookConfig__WEBPACK_IMPORTED_MODULE_3__["VueBookConfig"](options));
const createComponent = (options) => _classes_Main_VueBookRouteFactory__WEBPACK_IMPORTED_MODULE_0__["default"].createComponent(new _classes_Main_VueBookConfig__WEBPACK_IMPORTED_MODULE_3__["VueBookConfig"](options));
/** @deprecated use createRoute instead */
/* harmony default export */ __webpack_exports__["default"] = (function (requireContext, path) {
    return createRoute(new _classes_Main_VueBookConfig__WEBPACK_IMPORTED_MODULE_3__["VueBookConfig"]({
        requireContext,
        path,
    }));
});


/***/ }),

/***/ "./src/classes/Main/TreeFile.ts":
/*!**************************************!*\
  !*** ./src/classes/Main/TreeFile.ts ***!
  \**************************************/
/*! exports provided: TreeFile */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TreeFile", function() { return TreeFile; });
class TreeFile {
    constructor(data = {}) {
        this.path = '';
        this.component = null; // demo component
        this.folder = null;
        Object.assign(this, data);
    }
    openFolder() {
        this.folder && this.folder.open();
    }
    // returns `ComponentDemo.vue`
    getFilename() {
        return this.path.split('/').pop() || '';
    }
    getFilenameWithoutExtension() {
        return this.getFilename().split('.')[0];
    }
    getParentFolderPath() {
        return this.path.split('/').slice(0, -1).join('/');
    }
}


/***/ }),

/***/ "./src/classes/Main/TreeFileCollection.ts":
/*!************************************************!*\
  !*** ./src/classes/Main/TreeFileCollection.ts ***!
  \************************************************/
/*! exports provided: TreeFileCollection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TreeFileCollection", function() { return TreeFileCollection; });
class TreeFileCollection {
    constructor(data = {}) {
        this.treeFiles = [];
        Object.assign(this, data);
    }
}


/***/ }),

/***/ "./src/classes/Main/TreeFolder.ts":
/*!****************************************!*\
  !*** ./src/classes/Main/TreeFolder.ts ***!
  \****************************************/
/*! exports provided: TreeFolder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TreeFolder", function() { return TreeFolder; });
class TreeFolder {
    constructor(data = {}) {
        this.name = '';
        this.isOpen = false;
        this.folders = [];
        this.files = [];
        this.parentFolder = null;
        Object.assign(this, data);
    }
    static createFromDemoFileCollection(treeFileCollection) {
        const folderTemporary = new TreeFolder();
        // Add all files to temporary folder.
        const files = treeFileCollection.treeFiles;
        files.forEach((node) => folderTemporary.addTreeFile(node));
        const rootFolder = folderTemporary.folders[0] || folderTemporary;
        // Bind nodes to folders.
        rootFolder.fillParents();
        // Open topmost folder for convenience.
        rootFolder.open();
        return rootFolder;
    }
    /**
     * TODO Figure out how is that different from 'addFile'
     */
    addFile(treeFile, relativePath) {
        if (relativePath) {
            const folderNameArray = relativePath.split('/');
            const folderName = folderNameArray.shift();
            this.findOrCreateFolder(folderName)
                .addFile(treeFile, folderNameArray.join('/'));
            return;
        }
        this.files.push(treeFile);
    }
    toggle() {
        this.isOpen ? this.close() : this.open();
    }
    open() {
        this.isOpen = true;
        if (this.parentFolder && !this.parentFolder.isOpen) {
            this.parentFolder.open();
        }
    }
    close() {
        this.isOpen = false;
        this.folders.forEach(folder => folder.close());
    }
    findOrCreateFolder(name) {
        const foundFolder = this.folders.find(folder => folder.name === name);
        if (foundFolder) {
            return foundFolder;
        }
        const folder = new TreeFolder({ name });
        this.folders.push(folder);
        return folder;
    }
    /**
     * Create reverse relations in a tree.
     */
    fillParents() {
        this.files.forEach((treeFile) => {
            treeFile.folder = this;
        });
        this.folders.forEach((treeFolder) => {
            treeFolder.parentFolder = this;
            treeFolder.fillParents();
        });
    }
    /**
     * TODO Figure out how is that different from 'addTreeFile'
     */
    addTreeFile(treeFile) {
        const relativePath = treeFile.getParentFolderPath().split('/').slice(1)
            .join('/');
        this.addFile(treeFile, relativePath);
    }
    isEmpty() {
        return !(this.folders.length || this.files.length);
    }
    /**
     * Take only open folders from existing tree.
     * This acts as clone and doesn't have files.
     * Intended for saving in storage to keep open folders synced.
     */
    getOpenFolders() {
        return this.folders.filter(folder => folder.isOpen)
            .map((folder) => {
            return new TreeFolder({
                name: folder.name,
                folders: folder.getOpenFolders(),
                isOpen: true,
            });
        });
    }
    /**
     * Open all folders from passed structure. Nesting counts.
     */
    mergeWithFolders(folders) {
        folders.forEach((folder) => {
            const selfFolder = this.folders.find((selfFolder) => {
                return folder.name === selfFolder.name;
            });
            if (!selfFolder) {
                return;
            }
            selfFolder.isOpen = true;
            selfFolder.mergeWithFolders(folder.folders);
        });
    }
}


/***/ }),

/***/ "./src/classes/Main/VueBookConfig.ts":
/*!*******************************************!*\
  !*** ./src/classes/Main/VueBookConfig.ts ***!
  \*******************************************/
/*! exports provided: VueBookConfig */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VueBookConfig", function() { return VueBookConfig; });
class VueBookConfig {
    constructor(data = {}) {
        this.hideFileExtensions = false;
        this.hideNavigation = false;
        if (!data.requireContext) {
            throw (`'requireContext' is not defined on VueBookConfig`);
        }
        Object.assign(this, data);
    }
}


/***/ }),

/***/ "./src/classes/Main/VueBookRouteFactory.ts":
/*!*************************************************!*\
  !*** ./src/classes/Main/VueBookRouteFactory.ts ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VueBookRouteFactory; });
/* harmony import */ var _TreeFile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TreeFile */ "./src/classes/Main/TreeFile.ts");
/* harmony import */ var _components_DemoPage_VueBookRoot_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../components/DemoPage/VueBookRoot.vue */ "./src/components/DemoPage/VueBookRoot.vue");
/* harmony import */ var _TreeFileCollection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TreeFileCollection */ "./src/classes/Main/TreeFileCollection.ts");
/* harmony import */ var _TreeFolder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TreeFolder */ "./src/classes/Main/TreeFolder.ts");




/**
 * Creates route for vue-router with all necessary boilerplate.
 */
class VueBookRouteFactory {
    static createRoute(vueBookConfig) {
        const requireContext = vueBookConfig.requireContext;
        const path = vueBookConfig.path;
        const treeFileCollection = new _TreeFileCollection__WEBPACK_IMPORTED_MODULE_2__["TreeFileCollection"]({
            treeFiles: requireContext.keys().map((key) => {
                // requireContext(key).default - webpack 4
                // requireContext(key) - webpack 2
                const component = requireContext(key).default || requireContext(key);
                return new _TreeFile__WEBPACK_IMPORTED_MODULE_0__["TreeFile"]({
                    path: path + key.substr(1),
                    component,
                });
            }),
        });
        return {
            path: path + '*',
            component: _components_DemoPage_VueBookRoot_vue__WEBPACK_IMPORTED_MODULE_1__["default"],
            meta: {
                treeFolder: _TreeFolder__WEBPACK_IMPORTED_MODULE_3__["TreeFolder"].createFromDemoFileCollection(treeFileCollection),
                treeFileCollection,
                hideFileExtensions: vueBookConfig.hideFileExtensions,
                hideNavigation: vueBookConfig.hideNavigation,
            },
        };
    }
    static createComponent(vueBookConfig) {
        const requireContext = vueBookConfig.requireContext;
        const path = vueBookConfig.path;
        const treeFileCollection = new _TreeFileCollection__WEBPACK_IMPORTED_MODULE_2__["TreeFileCollection"]({
            treeFiles: requireContext.keys().map((key) => {
                // requireContext(key).default - webpack 4
                // requireContext(key) - webpack 2
                const component = requireContext(key).default || requireContext(key);
                return new _TreeFile__WEBPACK_IMPORTED_MODULE_0__["TreeFile"]({
                    path: path + key.substr(1),
                    component,
                });
            }),
        });
        return {
            render: (createElement) => {
                return createElement(_components_DemoPage_VueBookRoot_vue__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    props: {
                        treeFolderDefault: _TreeFolder__WEBPACK_IMPORTED_MODULE_3__["TreeFolder"].createFromDemoFileCollection(treeFileCollection),
                        treeFileCollectionDefault: treeFileCollection,
                        hideFileExtensionsDefault: vueBookConfig.hideFileExtensions,
                        hideNavigationDefault: vueBookConfig.hideNavigation,
                    },
                });
            },
        };
    }
}


/***/ }),

/***/ "./src/classes/Mapper/DemoFolderMapper.ts":
/*!************************************************!*\
  !*** ./src/classes/Mapper/DemoFolderMapper.ts ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DemoFolderMapper; });
/* harmony import */ var _Main_TreeFolder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Main/TreeFolder */ "./src/classes/Main/TreeFolder.ts");
/* harmony import */ var _TreeFileMapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TreeFileMapper */ "./src/classes/Mapper/TreeFileMapper.ts");


class DemoFolderMapper {
    static map({ name = '', isOpen = false, files = [], folders = [] } = {}) {
        return new _Main_TreeFolder__WEBPACK_IMPORTED_MODULE_0__["TreeFolder"]({
            name,
            isOpen,
            files: files.map(_TreeFileMapper__WEBPACK_IMPORTED_MODULE_1__["TreeFileMapper"].toClass),
            folders: folders.map(DemoFolderMapper.map),
        });
    }
    static transform(treeFolder) {
        return {
            name: treeFolder.name,
            isOpen: treeFolder.isOpen,
            files: treeFolder.files.map(_TreeFileMapper__WEBPACK_IMPORTED_MODULE_1__["TreeFileMapper"].toComponent),
            folders: treeFolder.folders.map(DemoFolderMapper.transform),
        };
    }
}


/***/ }),

/***/ "./src/classes/Mapper/TreeFileMapper.ts":
/*!**********************************************!*\
  !*** ./src/classes/Mapper/TreeFileMapper.ts ***!
  \**********************************************/
/*! exports provided: TreeFileMapper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TreeFileMapper", function() { return TreeFileMapper; });
/* harmony import */ var _Main_TreeFile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Main/TreeFile */ "./src/classes/Main/TreeFile.ts");

class TreeFileMapper {
    static toClass({ path, component }) {
        return new _Main_TreeFile__WEBPACK_IMPORTED_MODULE_0__["TreeFile"]({
            path,
            component,
        });
    }
    static toComponent(demoFile) {
        return {
            path: demoFile.path,
            component: {},
        };
    }
}


/***/ }),

/***/ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue":
/*!*****************************************************************!*\
  !*** ./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ComButtonIcon_vue_vue_type_template_id_5aadf9fc___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ComButtonIcon.vue?vue&type=template&id=5aadf9fc& */ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=template&id=5aadf9fc&");
/* harmony import */ var _ComButtonIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ComButtonIcon.vue?vue&type=script&lang=js& */ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport *//* harmony import */ var _ComButtonIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ComButtonIcon.vue?vue&type=style&index=0&lang=scss& */ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _ComButtonIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _ComButtonIcon_vue_vue_type_template_id_5aadf9fc___WEBPACK_IMPORTED_MODULE_0__["render"],
  _ComButtonIcon_vue_vue_type_template_id_5aadf9fc___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=script&lang=js&":
/*!******************************************************************************************!*\
  !*** ./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=script&lang=js& ***!
  \******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../../node_modules/babel-loader/lib!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./ComButtonIcon.vue?vue&type=script&lang=js& */ "../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=script&lang=js&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss&":
/*!***************************************************************************************************!*\
  !*** ./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss& ***!
  \***************************************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../../node_modules/style-loader!../../../../../../node_modules/css-loader!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/sass-loader/lib/loader.js!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./ComButtonIcon.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=template&id=5aadf9fc&":
/*!************************************************************************************************!*\
  !*** ./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=template&id=5aadf9fc& ***!
  \************************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_template_id_5aadf9fc___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./ComButtonIcon.vue?vue&type=template&id=5aadf9fc& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComButtonIcon/ComButtonIcon.vue?vue&type=template&id=5aadf9fc&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_template_id_5aadf9fc___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ComButtonIcon_vue_vue_type_template_id_5aadf9fc___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/DemoPage/ComInput/VueBookInput.vue":
/*!***********************************************************!*\
  !*** ./src/components/DemoPage/ComInput/VueBookInput.vue ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _VueBookInput_vue_vue_type_template_id_62416c18___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VueBookInput.vue?vue&type=template&id=62416c18& */ "./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=template&id=62416c18&");
/* harmony import */ var _VueBookInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VueBookInput.vue?vue&type=script&lang=ts& */ "./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _VueBookInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VueBookInput.vue?vue&type=style&index=0&lang=scss& */ "./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _VueBookInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _VueBookInput_vue_vue_type_template_id_62416c18___WEBPACK_IMPORTED_MODULE_0__["render"],
  _VueBookInput_vue_vue_type_template_id_62416c18___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/DemoPage/ComInput/VueBookInput.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=script&lang=ts&":
/*!************************************************************************************!*\
  !*** ./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=script&lang=ts& ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../../node_modules/ts-loader??ref--3!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookInput.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss&":
/*!*********************************************************************************************!*\
  !*** ./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss& ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../../node_modules/style-loader!../../../../../../node_modules/css-loader!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/sass-loader/lib/loader.js!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookInput.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=template&id=62416c18&":
/*!******************************************************************************************!*\
  !*** ./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=template&id=62416c18& ***!
  \******************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_template_id_62416c18___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookInput.vue?vue&type=template&id=62416c18& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/ComInput/VueBookInput.vue?vue&type=template&id=62416c18&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_template_id_62416c18___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookInput_vue_vue_type_template_id_62416c18___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/DemoPage/DemoPageConfig.ts":
/*!***************************************************!*\
  !*** ./src/components/DemoPage/DemoPageConfig.ts ***!
  \***************************************************/
/*! exports provided: DemoPageMode, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DemoPageMode", function() { return DemoPageMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DemoPageConfig; });
var DemoPageMode;
(function (DemoPageMode) {
    DemoPageMode["Tree"] = "Tree";
    DemoPageMode["Search"] = "Search";
    DemoPageMode["Hidden"] = "Hidden";
})(DemoPageMode || (DemoPageMode = {}));
class DemoPageConfig {
    constructor(data = {}) {
        this.mode = DemoPageMode.Search;
        this.isFlat = false;
        this.searchText = '';
        this.width = 300;
        Object.assign(this, data);
    }
}


/***/ }),

/***/ "./src/components/DemoPage/VueBookMenu.vue":
/*!*************************************************!*\
  !*** ./src/components/DemoPage/VueBookMenu.vue ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _VueBookMenu_vue_vue_type_template_id_a008a0be___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VueBookMenu.vue?vue&type=template&id=a008a0be& */ "./src/components/DemoPage/VueBookMenu.vue?vue&type=template&id=a008a0be&");
/* harmony import */ var _VueBookMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VueBookMenu.vue?vue&type=script&lang=ts& */ "./src/components/DemoPage/VueBookMenu.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _VueBookMenu_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VueBookMenu.vue?vue&type=style&index=0&lang=scss& */ "./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _VueBookMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _VueBookMenu_vue_vue_type_template_id_a008a0be___WEBPACK_IMPORTED_MODULE_0__["render"],
  _VueBookMenu_vue_vue_type_template_id_a008a0be___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/DemoPage/VueBookMenu.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/DemoPage/VueBookMenu.vue?vue&type=script&lang=ts&":
/*!**************************************************************************!*\
  !*** ./src/components/DemoPage/VueBookMenu.vue?vue&type=script&lang=ts& ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookMenu.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss&":
/*!***********************************************************************************!*\
  !*** ./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss& ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookMenu.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/DemoPage/VueBookMenu.vue?vue&type=template&id=a008a0be&":
/*!********************************************************************************!*\
  !*** ./src/components/DemoPage/VueBookMenu.vue?vue&type=template&id=a008a0be& ***!
  \********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_template_id_a008a0be___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookMenu.vue?vue&type=template&id=a008a0be& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookMenu.vue?vue&type=template&id=a008a0be&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_template_id_a008a0be___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookMenu_vue_vue_type_template_id_a008a0be___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/DemoPage/VueBookRoot.vue":
/*!*************************************************!*\
  !*** ./src/components/DemoPage/VueBookRoot.vue ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _VueBookRoot_vue_vue_type_template_id_6bf2bcb8___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VueBookRoot.vue?vue&type=template&id=6bf2bcb8& */ "./src/components/DemoPage/VueBookRoot.vue?vue&type=template&id=6bf2bcb8&");
/* harmony import */ var _VueBookRoot_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VueBookRoot.vue?vue&type=script&lang=ts& */ "./src/components/DemoPage/VueBookRoot.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _VueBookRoot_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VueBookRoot.vue?vue&type=style&index=0&lang=scss& */ "./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _VueBookRoot_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _VueBookRoot_vue_vue_type_template_id_6bf2bcb8___WEBPACK_IMPORTED_MODULE_0__["render"],
  _VueBookRoot_vue_vue_type_template_id_6bf2bcb8___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/DemoPage/VueBookRoot.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/DemoPage/VueBookRoot.vue?vue&type=script&lang=ts&":
/*!**************************************************************************!*\
  !*** ./src/components/DemoPage/VueBookRoot.vue?vue&type=script&lang=ts& ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookRoot.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss&":
/*!***********************************************************************************!*\
  !*** ./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss& ***!
  \***********************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookRoot.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/DemoPage/VueBookRoot.vue?vue&type=template&id=6bf2bcb8&":
/*!********************************************************************************!*\
  !*** ./src/components/DemoPage/VueBookRoot.vue?vue&type=template&id=6bf2bcb8& ***!
  \********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_template_id_6bf2bcb8___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookRoot.vue?vue&type=template&id=6bf2bcb8& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/DemoPage/VueBookRoot.vue?vue&type=template&id=6bf2bcb8&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_template_id_6bf2bcb8___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookRoot_vue_vue_type_template_id_6bf2bcb8___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/DemoPage/VueBookTreeOptions.ts":
/*!*******************************************************!*\
  !*** ./src/components/DemoPage/VueBookTreeOptions.ts ***!
  \*******************************************************/
/*! exports provided: VueBookTreeOptionsInterface, VueBookTreeOptions */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VueBookTreeOptionsInterface", function() { return VueBookTreeOptionsInterface; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VueBookTreeOptions", function() { return VueBookTreeOptions; });
const VueBookTreeOptionsInterface = 'VueBookTreeOptionsInterface';
class VueBookTreeOptions {
    constructor(data = {}) {
        this.noRouter = false;
        this.selectedTreeFile = null;
        this.hideFileExtensions = false;
        Object.assign(this, data);
    }
}


/***/ }),

/***/ "./src/components/Exposed/ContainerFocusService.ts":
/*!*********************************************************!*\
  !*** ./src/components/Exposed/ContainerFocusService.ts ***!
  \*********************************************************/
/*! exports provided: ContainerFocusProvideMixin, ContainerFocusInjectMixin */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContainerFocusProvideMixin", function() { return ContainerFocusProvideMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContainerFocusInjectMixin", function() { return ContainerFocusInjectMixin; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var asva_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! asva-helpers */ "../../node_modules/asva-helpers/dist/src/index.esm.js");


const createContainerFocusService = () => new vue__WEBPACK_IMPORTED_MODULE_0___default.a({
    data: () => ({
        focusedContainers: []
    }),
    methods: {
        focusContainer(id) {
            this.focusedContainers.push(id);
        },
        unfocusContainer(id) {
            asva_helpers__WEBPACK_IMPORTED_MODULE_1__["ArrayHelpers"].remove(this.focusedContainers, id);
        },
        isUnfocused(id) {
            return this.focusedContainers.length
                && !this.focusedContainers.includes(id);
        }
    }
});
const ContainerFocusProvideMixin = {
    provide() {
        return {
            vbFocusService: createContainerFocusService()
        };
    }
};
const ContainerFocusInjectMixin = {
    data() {
        return {
            id: Math.round(Math.random() * 100000) + ''
        };
    },
    props: {
        focus: Boolean,
    },
    inject: {
        vbFocusService: {
            default: null
        }
    },
    created() {
        if (!this.vbFocusService) {
            return;
        }
        if (this.focus) {
            this.vbFocusService.focusContainer(this.id);
        }
    },
    beforeDestroy() {
        if (!this.vbFocusService) {
            return;
        }
        if (this.focus) {
            this.vbFocusService.unfocusContainer(this.id);
        }
    },
    computed: {
        isHiddenAsUnfocused() {
            if (!this.vbFocusService) {
                return;
            }
            return this.vbFocusService.isUnfocused(this.id);
        }
    }
};


/***/ }),

/***/ "./src/components/Exposed/VbCard.vue":
/*!*******************************************!*\
  !*** ./src/components/Exposed/VbCard.vue ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _VbCard_vue_vue_type_template_id_2c0fdc7b___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VbCard.vue?vue&type=template&id=2c0fdc7b& */ "./src/components/Exposed/VbCard.vue?vue&type=template&id=2c0fdc7b&");
/* harmony import */ var _VbCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VbCard.vue?vue&type=script&lang=ts& */ "./src/components/Exposed/VbCard.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _VbCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VbCard.vue?vue&type=style&index=0&lang=scss& */ "./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _VbCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _VbCard_vue_vue_type_template_id_2c0fdc7b___WEBPACK_IMPORTED_MODULE_0__["render"],
  _VbCard_vue_vue_type_template_id_2c0fdc7b___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/Exposed/VbCard.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/Exposed/VbCard.vue?vue&type=script&lang=ts&":
/*!********************************************************************!*\
  !*** ./src/components/Exposed/VbCard.vue?vue&type=script&lang=ts& ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbCard.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss&":
/*!*****************************************************************************!*\
  !*** ./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss& ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbCard.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/Exposed/VbCard.vue?vue&type=template&id=2c0fdc7b&":
/*!**************************************************************************!*\
  !*** ./src/components/Exposed/VbCard.vue?vue&type=template&id=2c0fdc7b& ***!
  \**************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_template_id_2c0fdc7b___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbCard.vue?vue&type=template&id=2c0fdc7b& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbCard.vue?vue&type=template&id=2c0fdc7b&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_template_id_2c0fdc7b___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VbCard_vue_vue_type_template_id_2c0fdc7b___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/Exposed/VbDemo.vue":
/*!*******************************************!*\
  !*** ./src/components/Exposed/VbDemo.vue ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _VbDemo_vue_vue_type_template_id_5f9cbdce___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VbDemo.vue?vue&type=template&id=5f9cbdce& */ "./src/components/Exposed/VbDemo.vue?vue&type=template&id=5f9cbdce&");
/* harmony import */ var _VbDemo_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VbDemo.vue?vue&type=script&lang=ts& */ "./src/components/Exposed/VbDemo.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _VbDemo_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VbDemo.vue?vue&type=style&index=0&lang=scss& */ "./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _VbDemo_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _VbDemo_vue_vue_type_template_id_5f9cbdce___WEBPACK_IMPORTED_MODULE_0__["render"],
  _VbDemo_vue_vue_type_template_id_5f9cbdce___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/Exposed/VbDemo.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/Exposed/VbDemo.vue?vue&type=script&lang=ts&":
/*!********************************************************************!*\
  !*** ./src/components/Exposed/VbDemo.vue?vue&type=script&lang=ts& ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbDemo.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss&":
/*!*****************************************************************************!*\
  !*** ./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss& ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbDemo.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/Exposed/VbDemo.vue?vue&type=template&id=5f9cbdce&":
/*!**************************************************************************!*\
  !*** ./src/components/Exposed/VbDemo.vue?vue&type=template&id=5f9cbdce& ***!
  \**************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_template_id_5f9cbdce___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VbDemo.vue?vue&type=template&id=5f9cbdce& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Exposed/VbDemo.vue?vue&type=template&id=5f9cbdce&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_template_id_5f9cbdce___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VbDemo_vue_vue_type_template_id_5f9cbdce___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/FileTree/BookComponentListFolder.vue":
/*!*************************************************************!*\
  !*** ./src/components/FileTree/BookComponentListFolder.vue ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BookComponentListFolder_vue_vue_type_template_id_732c849b___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BookComponentListFolder.vue?vue&type=template&id=732c849b& */ "./src/components/FileTree/BookComponentListFolder.vue?vue&type=template&id=732c849b&");
/* harmony import */ var _BookComponentListFolder_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BookComponentListFolder.vue?vue&type=script&lang=ts& */ "./src/components/FileTree/BookComponentListFolder.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _BookComponentListFolder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BookComponentListFolder.vue?vue&type=style&index=0&lang=scss& */ "./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _BookComponentListFolder_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _BookComponentListFolder_vue_vue_type_template_id_732c849b___WEBPACK_IMPORTED_MODULE_0__["render"],
  _BookComponentListFolder_vue_vue_type_template_id_732c849b___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/FileTree/BookComponentListFolder.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/FileTree/BookComponentListFolder.vue?vue&type=script&lang=ts&":
/*!**************************************************************************************!*\
  !*** ./src/components/FileTree/BookComponentListFolder.vue?vue&type=script&lang=ts& ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListFolder.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss&":
/*!***********************************************************************************************!*\
  !*** ./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss& ***!
  \***********************************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListFolder.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/FileTree/BookComponentListFolder.vue?vue&type=template&id=732c849b&":
/*!********************************************************************************************!*\
  !*** ./src/components/FileTree/BookComponentListFolder.vue?vue&type=template&id=732c849b& ***!
  \********************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_template_id_732c849b___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListFolder.vue?vue&type=template&id=732c849b& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListFolder.vue?vue&type=template&id=732c849b&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_template_id_732c849b___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListFolder_vue_vue_type_template_id_732c849b___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/FileTree/BookComponentListItem.vue":
/*!***********************************************************!*\
  !*** ./src/components/FileTree/BookComponentListItem.vue ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BookComponentListItem_vue_vue_type_template_id_1bef2a00___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BookComponentListItem.vue?vue&type=template&id=1bef2a00& */ "./src/components/FileTree/BookComponentListItem.vue?vue&type=template&id=1bef2a00&");
/* harmony import */ var _BookComponentListItem_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./BookComponentListItem.vue?vue&type=script&lang=ts& */ "./src/components/FileTree/BookComponentListItem.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _BookComponentListItem_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BookComponentListItem.vue?vue&type=style&index=0&lang=scss& */ "./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _BookComponentListItem_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _BookComponentListItem_vue_vue_type_template_id_1bef2a00___WEBPACK_IMPORTED_MODULE_0__["render"],
  _BookComponentListItem_vue_vue_type_template_id_1bef2a00___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/FileTree/BookComponentListItem.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/FileTree/BookComponentListItem.vue?vue&type=script&lang=ts&":
/*!************************************************************************************!*\
  !*** ./src/components/FileTree/BookComponentListItem.vue?vue&type=script&lang=ts& ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListItem.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss&":
/*!*********************************************************************************************!*\
  !*** ./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss& ***!
  \*********************************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListItem.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/FileTree/BookComponentListItem.vue?vue&type=template&id=1bef2a00&":
/*!******************************************************************************************!*\
  !*** ./src/components/FileTree/BookComponentListItem.vue?vue&type=template&id=1bef2a00& ***!
  \******************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_template_id_1bef2a00___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./BookComponentListItem.vue?vue&type=template&id=1bef2a00& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/BookComponentListItem.vue?vue&type=template&id=1bef2a00&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_template_id_1bef2a00___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BookComponentListItem_vue_vue_type_template_id_1bef2a00___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/FileTree/DemoFileList.vue":
/*!**************************************************!*\
  !*** ./src/components/FileTree/DemoFileList.vue ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _DemoFileList_vue_vue_type_template_id_2bfa6312___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./DemoFileList.vue?vue&type=template&id=2bfa6312& */ "./src/components/FileTree/DemoFileList.vue?vue&type=template&id=2bfa6312&");
/* harmony import */ var _DemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DemoFileList.vue?vue&type=script&lang=ts& */ "./src/components/FileTree/DemoFileList.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _DemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./DemoFileList.vue?vue&type=style&index=0&lang=scss& */ "./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _DemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _DemoFileList_vue_vue_type_template_id_2bfa6312___WEBPACK_IMPORTED_MODULE_0__["render"],
  _DemoFileList_vue_vue_type_template_id_2bfa6312___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/FileTree/DemoFileList.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/FileTree/DemoFileList.vue?vue&type=script&lang=ts&":
/*!***************************************************************************!*\
  !*** ./src/components/FileTree/DemoFileList.vue?vue&type=script&lang=ts& ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./DemoFileList.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss&":
/*!************************************************************************************!*\
  !*** ./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss& ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./DemoFileList.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/FileTree/DemoFileList.vue?vue&type=template&id=2bfa6312&":
/*!*********************************************************************************!*\
  !*** ./src/components/FileTree/DemoFileList.vue?vue&type=template&id=2bfa6312& ***!
  \*********************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_template_id_2bfa6312___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./DemoFileList.vue?vue&type=template&id=2bfa6312& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/DemoFileList.vue?vue&type=template&id=2bfa6312&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_template_id_2bfa6312___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DemoFileList_vue_vue_type_template_id_2bfa6312___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/FileTree/ListCursor.ts":
/*!***********************************************!*\
  !*** ./src/components/FileTree/ListCursor.ts ***!
  \***********************************************/
/*! exports provided: ListCursor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListCursor", function() { return ListCursor; });
class ListCursor {
    constructor(data = {}) {
        this.preSelectedItem = null;
        Object.assign(this, data);
    }
    clean() {
        this.preSelectedItem = null;
    }
}


/***/ }),

/***/ "./src/components/FileTree/TreeDemoFileList.vue":
/*!******************************************************!*\
  !*** ./src/components/FileTree/TreeDemoFileList.vue ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TreeDemoFileList_vue_vue_type_template_id_abe00f60___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./TreeDemoFileList.vue?vue&type=template&id=abe00f60& */ "./src/components/FileTree/TreeDemoFileList.vue?vue&type=template&id=abe00f60&");
/* harmony import */ var _TreeDemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TreeDemoFileList.vue?vue&type=script&lang=ts& */ "./src/components/FileTree/TreeDemoFileList.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _TreeDemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./TreeDemoFileList.vue?vue&type=style&index=0&lang=scss& */ "./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _TreeDemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _TreeDemoFileList_vue_vue_type_template_id_abe00f60___WEBPACK_IMPORTED_MODULE_0__["render"],
  _TreeDemoFileList_vue_vue_type_template_id_abe00f60___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/FileTree/TreeDemoFileList.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/FileTree/TreeDemoFileList.vue?vue&type=script&lang=ts&":
/*!*******************************************************************************!*\
  !*** ./src/components/FileTree/TreeDemoFileList.vue?vue&type=script&lang=ts& ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./TreeDemoFileList.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss&":
/*!****************************************************************************************!*\
  !*** ./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss& ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./TreeDemoFileList.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/FileTree/TreeDemoFileList.vue?vue&type=template&id=abe00f60&":
/*!*************************************************************************************!*\
  !*** ./src/components/FileTree/TreeDemoFileList.vue?vue&type=template&id=abe00f60& ***!
  \*************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_template_id_abe00f60___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./TreeDemoFileList.vue?vue&type=template&id=abe00f60& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/FileTree/TreeDemoFileList.vue?vue&type=template&id=abe00f60&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_template_id_abe00f60___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TreeDemoFileList_vue_vue_type_template_id_abe00f60___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/components/Service/VueBookResizeLine.vue":
/*!******************************************************!*\
  !*** ./src/components/Service/VueBookResizeLine.vue ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _VueBookResizeLine_vue_vue_type_template_id_4f11aa3d___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VueBookResizeLine.vue?vue&type=template&id=4f11aa3d& */ "./src/components/Service/VueBookResizeLine.vue?vue&type=template&id=4f11aa3d&");
/* harmony import */ var _VueBookResizeLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VueBookResizeLine.vue?vue&type=script&lang=ts& */ "./src/components/Service/VueBookResizeLine.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport *//* harmony import */ var _VueBookResizeLine_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VueBookResizeLine.vue?vue&type=style&index=0&lang=scss& */ "./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js */ "../../node_modules/vue-loader/lib/runtime/componentNormalizer.js");






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
  _VueBookResizeLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_1__["default"],
  _VueBookResizeLine_vue_vue_type_template_id_4f11aa3d___WEBPACK_IMPORTED_MODULE_0__["render"],
  _VueBookResizeLine_vue_vue_type_template_id_4f11aa3d___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"],
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "src/components/Service/VueBookResizeLine.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "./src/components/Service/VueBookResizeLine.vue?vue&type=script&lang=ts&":
/*!*******************************************************************************!*\
  !*** ./src/components/Service/VueBookResizeLine.vue?vue&type=script&lang=ts& ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/ts-loader??ref--3!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookResizeLine.vue?vue&type=script&lang=ts& */ "../../node_modules/ts-loader/index.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=script&lang=ts&");
/* empty/unused harmony star reexport */ /* harmony default export */ __webpack_exports__["default"] = (_node_modules_ts_loader_index_js_ref_3_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_script_lang_ts___WEBPACK_IMPORTED_MODULE_0__["default"]); 

/***/ }),

/***/ "./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss&":
/*!****************************************************************************************!*\
  !*** ./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss& ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/style-loader!../../../../../node_modules/css-loader!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/sass-loader/lib/loader.js!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookResizeLine.vue?vue&type=style&index=0&lang=scss& */ "../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/sass-loader/lib/loader.js!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=style&index=0&lang=scss&");
/* harmony import */ var _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_style_loader_index_js_node_modules_css_loader_index_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "./src/components/Service/VueBookResizeLine.vue?vue&type=template&id=4f11aa3d&":
/*!*************************************************************************************!*\
  !*** ./src/components/Service/VueBookResizeLine.vue?vue&type=template&id=4f11aa3d& ***!
  \*************************************************************************************/
/*! exports provided: render, staticRenderFns */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_template_id_4f11aa3d___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! -!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib??vue-loader-options!./VueBookResizeLine.vue?vue&type=template&id=4f11aa3d& */ "../../node_modules/vue-loader/lib/loaders/templateLoader.js?!../../node_modules/vue-loader/lib/index.js?!./src/components/Service/VueBookResizeLine.vue?vue&type=template&id=4f11aa3d&");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "render", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_template_id_4f11aa3d___WEBPACK_IMPORTED_MODULE_0__["render"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "staticRenderFns", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_VueBookResizeLine_vue_vue_type_template_id_4f11aa3d___WEBPACK_IMPORTED_MODULE_0__["staticRenderFns"]; });



/***/ }),

/***/ "./src/font-awesome-config.ts":
/*!************************************!*\
  !*** ./src/font-awesome-config.ts ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @fortawesome/fontawesome-svg-core */ "../../node_modules/@fortawesome/fontawesome-svg-core/index.es.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faArrowsAltV__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faArrowsAltV */ "../../node_modules/@fortawesome/free-solid-svg-icons/faArrowsAltV.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faArrowsAltV__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faArrowsAltV__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faBars__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faBars */ "../../node_modules/@fortawesome/free-solid-svg-icons/faBars.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faBars__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faBars__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faCaretDown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faCaretDown */ "../../node_modules/@fortawesome/free-solid-svg-icons/faCaretDown.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faCaretDown__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faCaretDown__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faCaretRight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faCaretRight */ "../../node_modules/@fortawesome/free-solid-svg-icons/faCaretRight.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faCaretRight__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faCaretRight__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faDotCircle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faDotCircle */ "../../node_modules/@fortawesome/free-solid-svg-icons/faDotCircle.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faDotCircle__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faDotCircle__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faExchangeAlt__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faExchangeAlt */ "../../node_modules/@fortawesome/free-solid-svg-icons/faExchangeAlt.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faExchangeAlt__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faExchangeAlt__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faFile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faFile */ "../../node_modules/@fortawesome/free-solid-svg-icons/faFile.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faFile__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faFile__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faFolder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faFolder */ "../../node_modules/@fortawesome/free-solid-svg-icons/faFolder.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faFolder__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faFolder__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faSearch__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faSearch */ "../../node_modules/@fortawesome/free-solid-svg-icons/faSearch.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faSearch__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faSearch__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faServer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faServer */ "../../node_modules/@fortawesome/free-solid-svg-icons/faServer.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faServer__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faServer__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faTimes */ "../../node_modules/@fortawesome/free-solid-svg-icons/faTimes.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _fortawesome_free_solid_svg_icons_faSync__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons/faSync */ "../../node_modules/@fortawesome/free-solid-svg-icons/faSync.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons_faSync__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_free_solid_svg_icons_faSync__WEBPACK_IMPORTED_MODULE_12__);
// Vue font awesome config.

// NOTE Importing them all in one import doesn't trigger webpack tree-shaking.
// As a result - whole file is included, giving additional 600Kb to bundle size.
// See https://github.com/FortAwesome/react-fontawesome/issues/70












_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__["library"].add(_fortawesome_free_solid_svg_icons_faServer__WEBPACK_IMPORTED_MODULE_10__["faServer"], _fortawesome_free_solid_svg_icons_faFolder__WEBPACK_IMPORTED_MODULE_8__["faFolder"], _fortawesome_free_solid_svg_icons_faSearch__WEBPACK_IMPORTED_MODULE_9__["faSearch"], _fortawesome_free_solid_svg_icons_faBars__WEBPACK_IMPORTED_MODULE_2__["faBars"], _fortawesome_free_solid_svg_icons_faExchangeAlt__WEBPACK_IMPORTED_MODULE_6__["faExchangeAlt"], _fortawesome_free_solid_svg_icons_faDotCircle__WEBPACK_IMPORTED_MODULE_5__["faDotCircle"], _fortawesome_free_solid_svg_icons_faCaretDown__WEBPACK_IMPORTED_MODULE_3__["faCaretDown"], _fortawesome_free_solid_svg_icons_faCaretRight__WEBPACK_IMPORTED_MODULE_4__["faCaretRight"], _fortawesome_free_solid_svg_icons_faFile__WEBPACK_IMPORTED_MODULE_7__["faFile"], _fortawesome_free_solid_svg_icons_faArrowsAltV__WEBPACK_IMPORTED_MODULE_1__["faArrowsAltV"], _fortawesome_free_solid_svg_icons_faSync__WEBPACK_IMPORTED_MODULE_12__["faSync"], _fortawesome_free_solid_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_11__["faTimes"]);


/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(/*! !../../../../node_modules/css-loader!../../../../node_modules/sass-loader/lib/loader.js!./app.scss */ "../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./src/scss/app.scss");

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(/*! ../../../../node_modules/style-loader/lib/addStyles.js */ "../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),

/***/ "./src/store/FoldersStore.ts":
/*!***********************************!*\
  !*** ./src/store/FoldersStore.ts ***!
  \***********************************/
/*! exports provided: FoldersStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FoldersStore", function() { return FoldersStore; });
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./storage */ "./src/store/storage.ts");
/* harmony import */ var _classes_Mapper_DemoFolderMapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../classes/Mapper/DemoFolderMapper */ "./src/classes/Mapper/DemoFolderMapper.ts");


const STORAGE_KEY = 'openFolders';
class FoldersStore {
    constructor() {
        this.openFolders = [];
    }
    load() {
        const data = _storage__WEBPACK_IMPORTED_MODULE_0__["default"].fetch(STORAGE_KEY) || [];
        const folders = data.map(_classes_Mapper_DemoFolderMapper__WEBPACK_IMPORTED_MODULE_1__["default"].map);
        this.openFolders = folders;
    }
    save() {
        const data = this.openFolders.map(_classes_Mapper_DemoFolderMapper__WEBPACK_IMPORTED_MODULE_1__["default"].transform);
        _storage__WEBPACK_IMPORTED_MODULE_0__["default"].store(STORAGE_KEY, data);
    }
}


/***/ }),

/***/ "./src/store/configStore.ts":
/*!**********************************!*\
  !*** ./src/store/configStore.ts ***!
  \**********************************/
/*! exports provided: ConfigStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfigStore", function() { return ConfigStore; });
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./storage */ "./src/store/storage.ts");
/* harmony import */ var _components_DemoPage_DemoPageConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/DemoPage/DemoPageConfig */ "./src/components/DemoPage/DemoPageConfig.ts");


const STORAGE_KEY = 'config';
class ConfigStore {
    constructor() {
        this.config = null;
    }
    load() {
        const data = _storage__WEBPACK_IMPORTED_MODULE_0__["default"].fetch(STORAGE_KEY) || new _components_DemoPage_DemoPageConfig__WEBPACK_IMPORTED_MODULE_1__["default"]();
        this.config = new _components_DemoPage_DemoPageConfig__WEBPACK_IMPORTED_MODULE_1__["default"](data);
    }
    save() {
        _storage__WEBPACK_IMPORTED_MODULE_0__["default"].store(STORAGE_KEY, this.config);
    }
}


/***/ }),

/***/ "./src/store/storage.ts":
/*!******************************!*\
  !*** ./src/store/storage.ts ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
const STORAGE_KEY = 'vue-book';
/* harmony default export */ __webpack_exports__["default"] = ({
    store(key, value) {
        const all = this.getAll();
        all[key] = value;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    },
    fetch(key) {
        return this.getAll()[key];
    },
    getAll() {
        const defaultItems = this.getDefault();
        if (localStorage.getItem(STORAGE_KEY) === undefined) {
            return defaultItems;
        }
        const storedItems = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Object.assign(defaultItems, storedItems);
    },
    getDefault() {
        return {};
    },
});


/***/ }),

/***/ "vue":
/*!**********************!*\
  !*** external "vue" ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_vue__;

/***/ })

/******/ });
});
//# sourceMappingURL=app.js.map